import PlusGradientIcon from 'ui-components/PlusGradientIcon';
import FilterGradientIcon from 'ui-components/FilterGradientIcon';
import MoreGradientIcon from 'ui-components/MoreGradientIcon';
import React, { useState } from 'react'
import { useQueryClient } from '@tanstack/react-query'
import AsyncTableListing from '../../ui-components/AsyncTableListing'
import DealFlowListSkeleton from './DealFlowListSkeleton'
import SelectionActionBar from 'ui-components/SelectionActionBar'
import { readTabsCache, writeTabsCache } from 'utils/dealFlowTabsCache'
import DealFlowToolbar from 'views/deal_flow_shell/DealFlowToolbar'
import NoData from '../../ui-components/NoData'
import NoStartupsIcon from '../../ui-components/icons/NoStartupsIcon'
import BreadcrumbHeader from '../../layout/BreadcrumbsHeader'
import SearchGradientIcon from '../../ui-components/SearchGradientIcon'
import ThemeBGWrapper from '../../ui-components/ThemeBGWrapper'
import { useTheme } from '@emotion/react'
import { ReactComponent as RoundDetailsIcon } from "assets/rounds_icons/round_details_icon.svg"
import { Autocomplete, Box, CircularProgress, Dialog, Grid, IconButton, Menu, MenuItem, Paper, Stack, Tooltip, Typography, useMediaQuery, Switch } from '@mui/material'
import CustomTabs from '../../ui-components/CustomTabs'
import { TabContext } from '@mui/lab'
import { Add, CancelRounded, ConnectWithoutContact, Description, DoneAll, DoneRounded, EmailOutlined, FiberNew, FiberNewRounded, FilterAltOutlined, FilterAltRounded, Info, LanguageOutlined, LinkedIn, Message, MessageOutlined, More, MoreVert, NewReleasesOutlined, Notes, OpenInNew, PublishedWithChanges, RateReview, RocketLaunch, Search, ThumbDown, ThumbUp, WhatsApp, PlayArrow, UploadFile, ViewKanbanOutlined, AccountTreeOutlined, SettingsOutlined } from '@mui/icons-material'
import { makeStyles } from '@mui/styles'
import { amountInWords, capitalizedSentence, checkForDomain, convertCurrencyAmountRange, formatDealSource, getFileIcon, hasPermission, navigateToDomain } from '../../utils'
import { Link, useNavigate, useSearchParams } from 'react-router-dom'
import CustomInputField from 'ui-components/CustomInputField'
import { B400, WHITEBG } from 'ui-components/CustomButton';
import { Primary, Secondary } from 'ui-components/Buttons';
import { ReactComponent as MoreOptionsIcon } from "assets/rounds_icons/more_solid_icon.svg";
import NeedHelpButton from 'ui-components/NeedHelpButton'
import FilterPopup from "./popups/FilterPopup"
import ModalComponent from 'ui-components/ModalComponent'
import FeedbackPopup from './popups/FeedbackPopup'
import ShowInterestPopup from './popups/ShowInterestPopup'
import ShortlistConfirmationPopup from "ui-components/popups/DeleteConfirmationPopup"
import InvitedConfirmationPopup from "ui-components/popups/DeleteConfirmationPopup"
import InProgressConfirmationPopup from "ui-components/popups/DeleteConfirmationPopup"
import RejectedConfirmationPopup from "ui-components/popups/DeleteConfirmationPopup"
import RequestDocumentsPopup from "ui-components/popups/DeleteConfirmationPopup"
import Cookies from 'js-cookie'
import { FetchAllCategories, FetchAllStages, FetchAllSubCategories, FetchAllCurrencyLists } from 'api/utils'
import { UpdateStartupStatus } from 'api'
import InviteStartupPopup from './popups/InviteStartupPopup'
import PitchDeckImportPopup from './popups/PitchDeckImportPopup'
import AIShortlistPopup from './popups/AIShortlistPopup'
import { useSelector } from 'react-redux'
import { FetchAllStartupsListing, InviteStartupPOST, SaveFeedback, SaveInterest, SaveManageNotes, FetchInterestFeedbackStatus } from 'api'
import { ReactComponent as UploadPitchDeckIcon } from "assets/upload-pitchdeck.svg"

import PDFView from './popups/PDFView'
import CustomToast from 'ui-components/CustomToast'
import AlertDialog from 'ui-components/popups/AlertPopup'
import toast from 'react-hot-toast'
import placeHolderImageNew from 'assets/no_data_images/Startups/new_startups.svg'
import placeHolderImageShortlisted from 'assets/no_data_images/Startups/shortlisted_startpus.svg'
import placeHolderImageRejected from 'assets/no_data_images/Startups/rejected_startus.svg'
import { useToast } from 'context/ToastContext'
import { registerBatchCompletionCallback, unregisterBatchCompletionCallback } from 'components/ProcessingSnackbar'
import { ChangePipelineInvestorStatus, ChangeStatusForCurrentPipeline, DeletePipelineStatus, FetchPipelines, FetchPipelinesStatuses, ReorderPipelines, ReorderStatuses } from 'api/startup_applications'
import StartupStatusSelector from 'ui-components/StartupStatusSelector'
import { BulkUpdateInvestorPipeline, BulkUpdateInvestorStatus, CreateDealFlow, CreatePipeline, DeletePipelineFlow, MoveToDealFlowAPI, MoveToPipelineFlowAPI, UpdateDealFlowName, UpdatePipelineFlowName, ToggleAutoShortlist } from 'api/deal_flow'
import { resolveStatusLabel } from 'views/deal_flow_board/statusDefaults'
import MoveToPipelineFlowPopup from 'views/deal_flow/popups/MoveToPipelineFlowPopup'
import MoveToDealFlowPopup from 'views/deal_flow/popups/MoveToDealFlowPopup'
import DeleteConfirmationDialog from 'ui-components/popups/DeleteConfirmationPopup'
import DealFlowViewToggle from 'ui-components/DealFlowViewToggle'
import SettingsPopup from 'views/deal_flow/popups/SettingsPopup'
import CreateNewPipelineStatusPopup from 'views/deal_flow/popups/CreateNewPipelineStatusPopup'
import CreateDealFlowPopup from 'views/deal_flow/popups/CreateNewDealFlowPopup'
import { GetInvestorSetting } from 'api/investors'
import StartupRowDetails, { DEFAULT_HIDDEN_COLUMNS } from './StartupRowDetails'
import PitchReelButton from 'ui-components/PitchReelButton'
import CustomSwitch from 'ui-components/CustomSwitch'
import ReelModal from 'ui-components/ReelModal'
import { SparklesIcon } from 'lucide-react'
import { useProcessingSnackbar } from 'context/ProcessingSnackbarContext'
import { fetchInvitedCount } from 'hooks/useAutoShortlistRefresh'

// Jobs carry the investor's Bull delay; this is the extra time allowed for the queue
// to drain before the one refetch. Tune here if runs finish later than this.
const AUTO_SHORTLIST_GRACE_MS = 6000;

const useStyles = makeStyles((theme) => ({
  scrollTabs: {
    "&": {
      padding: "3rem"
    },
    // '& .MuiTabs-root > .MuiTabs-scroller > .MuiTabs-flexContainer' : {marginLeft: '2rem', gap: '5rem'}
  },
  mainScrollTabs: {
    '& > .Mui-disabled.MuiTabs-scrollButtons': {
      display: 'none',
      transition: 'all 1s ease'
    }
  }

  //     '& .MuiTabs-root > .Mui-disabled.MuiTabs-scrollButtons': {
  //         display: 'none !important',
  //         transition: 'all 1s ease'
  //     },
  // }
}));

const constants = {
  investor: "investor",
  rejected: "rejected",
  invited: "invited"
}

const StartupsListing = () => {
  const queryClient = useQueryClient();
  const { getIsShortlisting, clearCompletedBatches, addBatch, markUploadStepCompleted, removeBatch } = useProcessingSnackbar();
  const isShortlisting = React.useMemo(() => {
    return getIsShortlisting();
  }, [getIsShortlisting]);

  // console.log({isShortlisting})
  const theme = useTheme();
  const { addToast } = useToast();
  const classes = useStyles();
  const navigate = useNavigate();
  const userDetails = useSelector((state) => state?.investorDetails?.data);
  const userPermissions = useSelector((state) => state?.permissions?.userPermissions);
  let [investor_id, setInvestorID] = React.useState(Cookies.get("X-INV-ID") || null);
  const { mutateAsync: fetchPipelinesAsync, isLoading: isLoadingPipelines } = FetchPipelines({ investor_id: investor_id });
  // Seeded from the shared cache so the pipeline strip paints immediately when you
  // switch back from the board view instead of blanking out until the re-fetch lands.
  // See utils/dealFlowTabsCache for why the mutation-based fetches need this.
  const [pipelinesData, setPipelinesData] = React.useState(() => {
    const cached = readTabsCache(investor_id, 'pipelines');
    return cached ? { data: cached } : null;
  })
  const { data: fetchedSettingFromBackend, isLoading: isFetching } = GetInvestorSetting({
    investor_id,
    module: "deal_flow",
  });
  const [isAIShortlistProcessing, setIsAIShortlistProcessing] = React.useState(false)
  // Auto-shortlist state
  const [autoShortlistEnabled, setAutoShortlistEnabled] = useState(false);
  const [autoShortlistConfirmDialog, setAutoShortlistConfirmDialog] = useState(false);
  const [pendingAutoShortlistState, setPendingAutoShortlistState] = useState(null);
  const { mutateAsync: toggleAutoShortlistAsync } = ToggleAutoShortlist();

  // Load auto-shortlist settings from backend
  React.useEffect(() => {
    if (fetchedSettingFromBackend?.auto_shortlist) {
      setAutoShortlistEnabled(fetchedSettingFromBackend.auto_shortlist.enabled || false);
    }
  }, [fetchedSettingFromBackend]);

  const refetchPipelineTabs = React.useCallback(() => {
    fetchPipelinesAsync({ investor_id }, {
      onSuccess: (response) => {
        const mapped = response?.data?.data?.map(item => {
          return ({
            ...item,
            label: item?.name,
            value: item?._id,
            display_order: item?.display_order,
            // is_deletable: true,
            slug: item?.slug
          })
        }) || []
        setPipelinesData({ data: mapped })
        writeTabsCache(investor_id, 'pipelines', mapped)
      },
      onError: (response) => {
        // console.log(response, "error")
      }
    })
  }, [investor_id, fetchPipelinesAsync])

  React.useEffect(() => {
    refetchPipelineTabs()
  }, [investor_id])

  const { mutateAsync: fetchStatusesData, isLoading: isLoadingStatuses } = FetchPipelinesStatuses({ investor_id: investor_id })
  // Seeded from the shared cache - see the pipelinesData comment above.
  const [pipelineStatusesData, setPipelineStatusesData] = React.useState(() => {
    const cached = readTabsCache(investor_id, 'statuses')
    return cached ? { data: cached } : null
  })
  // console.log(pipelinesData, "pipelinesData")
  // console.log(pipelineStatusesData, "pipelineStatusesData")

  const isSmallScreen = useMediaQuery(theme.breakpoints.down('sm'));
  const pipelineTabsArray = !pipelinesData?.data ? [
    {
      value: "All",
      label: 'All',
      is_fixed: true,
      // icon: ThumbDown
    },
  ] : [
    // {
    //     value: "invited",
    //     label: 'New',
    //     count: 10,
    //     read: false,
    //     // icon: RocketLaunch
    // },
    // {
    //     value: "interested",
    //     label: 'Shortlisted',
    //     count: 10,
    //     read: false,
    //     // icon: ThumbUp
    // },
    // {
    //     value: "in-progress",
    //     label: 'Selected',
    //     count: 10,
    //     read: false,
    //     // icon: DoneAll
    // },
    // {
    //     value: "rejected",
    //     label: 'Rejected',
    //     count: 10,
    //     read: false,
    //     // icon: ThumbDown
    // },
    {
      value: "All",
      label: 'All',
      is_fixed: true
      // icon: ThumbDown
    },
    ...pipelinesData?.data
  ]
  const statusTabsArray = !pipelineStatusesData?.data ? [
    //  To Be UnCommented
    // {
    //     value: "All",
    //     label: 'All',
    //     is_fixed: true
    //     // icon: ThumbDown
    // },
    // {
    //     value: "invited", label: 'New', count: 10, read: false,
    //     // icon: RocketLaunch
    // },
  ] : [
    // {
    //     value: "invited", label: 'New', count: 10, read: false,
    //     // icon: RocketLaunch
    // },
    // {
    //     value: "interested", label: 'Shortlisted', count: 10, read: false,
    //     // icon: ThumbUp
    // },
    // {
    //     value: "in-progress", label: 'Selected', count: 10, read: false,
    //     // icon: DoneAll
    // },
    // {
    //     value: "rejected", label: 'Rejected', count: 10, read: false,
    //     // icon: ThumbDown
    // },
    //  To Be UnCommented
    // {
    //     value: "All",
    //     label: 'All',
    //     is_fixed: true
    //     // icon: ThumbDown
    // },
    ...pipelineStatusesData?.data
  ]
  const [page, setPage] = React.useState(1);
  const [limit, setLimit] = React.useState(10);
  const parsedCookieForQueryParams = Cookies.get("startups_query")
    ? JSON.parse(Cookies.get("startups_query"))
    : {};
  const [queryParams, setQueryParams] = React.useState(
    parsedCookieForQueryParams
  );

  const [stage, setStage] = React.useState(null);
  const [category, setCategory] = React.useState(null);
  const [sector, setSector] = React.useState(null);
  const pipeline_tab_value = Cookies.get("pipeline") ? JSON.parse(Cookies.get("pipeline")) : "All";

  const status_tab_value = Cookies.get("status") ? JSON.parse(Cookies.get("status")) : null

  // console.log(Cookies.get("status"), Cookies.get("pipeline"))
  const [mainTabValue, setMainTabValue] = React.useState(pipeline_tab_value ?? "All")
  // const [value, setValue] = React.useState(status_tab_value ?? "All")
  const [value, setValue] = React.useState(status_tab_value ?? null)
  const [search, setSearch] = React.useState("" || Cookies.get("search_startups"));
  const [reset, setReset] = React.useState(false);
  const [searchStatus, setSearchStatus] = React.useState(false);
  const [openFilter, setOpenFilter] = React.useState(false);
  const [reelModalOpen, setReelModalOpen] = React.useState(false);
  const [selectedReelItem, setSelectedReelItem] = React.useState(null);
  const [selectedReelViewType, setSelectedReelViewType] = React.useState('deal-flow');
  // const { data: transformedData, isRefetching: isRefetchingStartupListing, isLoading: isLoadingStartupListing, refetch: refetchListing } = FetchAllStartupsListing({ page, limit, status: value, investor_id: investor_id, queryParams, searchText: search })
  const [transformedData, setTransformedData] = React.useState(null);
  const {
    mutateAsync: startupListingAsync,
    status: startupListingStatus,
    error: startupListingError,
    isLoading: isLoadingStartupListing,
    isSuccess: isFetchedSuccessFully,
    data: startupListingResponse,
  } = FetchAllStartupsListing();

  const refetchStatusTabs = React.useCallback(() => {
    fetchStatusesData({ investor_id }, {
      onSuccess: (response) => {
        const mapped = response?.data?.data?.map(item => {
          return {
            ...item,
            mappedValue: item?.value,
            label: resolveStatusLabel(item),
            value: item?._id,
            display_order: item?.display_order,
          }
        }) || []
        setPipelineStatusesData({ data: mapped });
        writeTabsCache(investor_id, 'statuses', mapped)

        !value && response?.data?.data[0]?._id && setValue(response?.data?.data[0]?._id)
        // response?.data?.data?.find(item => item?._id !== value) && response?.data?.data[0]?._id && setValue(response?.data?.data[0]?._id)
        // response?.data?.data[0]?._id && setValue(response?.data?.data[0]?._id)
        // response?.data?.data[0]?._id && setValue("All")
        // console.log(response?.data?.data[0]?._id, "response")
      },
      onError: (response) => {
        // console.log(response, "response")
      },
    })
  }, [investor_id, fetchStatusesData])

  React.useEffect(() => {
    refetchStatusTabs()
  }, [investor_id])

  // AI shortlisting moves startups between statuses, so the status tabs and their
  // counts go stale. The listing already refetches on `isShortlisting` (see its deps
  // below), but the tabs were only fetched on mount - so after the FIRST shortlist run
  // the tabs still showed the old counts until the page remounted. Refetch them when a
  // run finishes (true -> false); the ref guard keeps this from firing on mount or when
  // a run starts.
  const wasShortlistingRef = React.useRef(isShortlisting);
  React.useEffect(() => {
    if (wasShortlistingRef.current && !isShortlisting) {
      refetchStatusTabs();
    }
    wasShortlistingRef.current = isShortlisting;
  }, [isShortlisting, refetchStatusTabs])

  const handleOpenReel = React.useCallback((item, isInvited) => {
    setSelectedReelItem(item);
    setSelectedReelViewType(isInvited ? 'deal-flow' : 'selected');
    setReelModalOpen(true);
  }, []);

  const handleCloseReel = React.useCallback(() => {
    setReelModalOpen(false);
    setSelectedReelItem(null);
  }, []);

  const isInNewStatus = constants["invited"] === pipelineStatusesData?.data?.find(item => item?._id === value)?.mappedValue;

  const { data: startup_stages, isRefetching: isRefetchingAllStages, isLoading: isLoadingAllStages, refetch: refetchAllStages } = FetchAllStages();
  const { data: startup_categories, isRefetching: isRefetchingAllCategories, isLoading: isLoadingAllCategories, refetch: refetchAllCategories } = FetchAllCategories();
  const { data: startup_sub_categories, isRefetching: isRefetchingAllSubcategories, isLoading: isLoadingAllSubcategories, refetch: refetchAllSubcategories } = FetchAllSubCategories({ category: queryParams?.category });

  const selectedStageId = React.useMemo(() => {
    return queryParams?.stage
      ? startup_stages?.filter(item => queryParams?.stage?.split(",")?.includes(item?.name)).map(item => item?._id)
      : null;
  }, [queryParams?.stage, startup_stages]);

  const selectedCategoryId = React.useMemo(() => {
    return queryParams?.category
      ? startup_categories?.filter(item => queryParams?.category?.split(",")?.includes(item?.name)).map(item => item?._id)
      : null;
  }, [queryParams?.category, startup_categories]);

  const selectedSectorId = React.useMemo(() => {
    return queryParams?.sector
      ? startup_sub_categories?.filter(item => queryParams?.sector?.split(",")?.includes(item?.sub_category)).map(item => item?._id)
      : null;
  }, [queryParams?.sector, startup_sub_categories]);


  const refetchListing = React.useCallback(() => {
    const payloadQueryParams = {
      ...(selectedStageId && { select_stages: selectedStageId }),
      ...(selectedCategoryId && { category: selectedCategoryId }),
      ...(selectedSectorId && { sub_sector: selectedSectorId }),
      ...(queryParams?.city && { city: queryParams?.city?.split(",") }),
    };

    const pipelineFilter = mainTabValue !== "All" ? { investor_pipeline_id: mainTabValue } : {};
    const investorStatusFilter = value && value !== "All" ? { investor_status_id: value } : {};

    startupListingAsync({
      payload: {
        // status: value ?? null,
        page: page ?? 1,
        limit: limit ?? 20,
        name: search ?? "",
        ...pipelineFilter,
        ...investorStatusFilter
      },
      investor_id,
      queryParams: payloadQueryParams
    }, {
      onSuccess: (response) => {
        setTransformedData({
          data: response?.data?.data || [],
          count: response?.data?.totalCount || 0,
          uniqueCountryCity: response?.data?.uniqueCountryCity || []
        });
      },
      onError: () => {
        setTransformedData({ data: [], count: 0, uniqueCountryCity: [] });
      }
    });
  }, [investor_id, value, page, limit, searchStatus && search, mainTabValue, selectedStageId, selectedCategoryId, selectedSectorId, queryParams?.city, isShortlisting]);


  React.useEffect(() => {
    if (searchStatus || [mainTabValue, value, page, limit, queryParams].some(Boolean)) {
      refetchListing();
    }
  }, [mainTabValue, value, page, limit, queryParams, searchStatus, refetchListing, isShortlisting]);

  // Auto-Shortlist queues one background job per invited startup. Rather than poll,
  // wait out the investor's Bull delay plus a grace and refetch the listing once -
  // rows only, since shortlisting never adds or removes a status or pipeline tab.
  const autoShortlistBatchRef = React.useRef(null);
  const autoShortlistTimerRef = React.useRef(null);
  const [isAutoShortlisting, setIsAutoShortlisting] = React.useState(false);

  const clearAutoShortlistTimer = React.useCallback(() => {
    if (autoShortlistTimerRef.current) {
      clearTimeout(autoShortlistTimerRef.current);
      autoShortlistTimerRef.current = null;
    }
  }, []);

  React.useEffect(() => clearAutoShortlistTimer, [clearAutoShortlistTimer]);

  // Opens the same snackbar the AI Shortlist uses; the timer below closes it.
  const startAutoShortlistWithSnackbar = React.useCallback((delayMs) => {
    const batchId = `auto-shortlist-${Date.now()}`;
    autoShortlistBatchRef.current = batchId;
    addBatch(batchId, {
      batchType: 'auto_shortlist',
      uploadStep: 'processing',
      uploadedFileNames: [],
      notifyOnComplete: false,
    });
    setIsAutoShortlisting(true);
    clearAutoShortlistTimer();
    autoShortlistTimerRef.current = setTimeout(() => {
      autoShortlistTimerRef.current = null;
      setIsAutoShortlisting(false);
      if (autoShortlistBatchRef.current) {
        markUploadStepCompleted(autoShortlistBatchRef.current);
        autoShortlistBatchRef.current = null;
      }
      refetchListing();
    }, Math.max(0, Number(delayMs) || 0) + AUTO_SHORTLIST_GRACE_MS);
  }, [addBatch, markUploadStepCompleted, refetchListing, clearAutoShortlistTimer]);

  // Clearing the search box must restore the full list. Search "commits" on Enter,
  // but deleting the text only fires onChange (which flips searchStatus to false) -
  // nothing re-fetches, so the list stays stuck on the previous (empty) search
  // result. Detect the non-empty -> empty transition and refetch the full list.
  const prevSearchRef = React.useRef(search);
  React.useEffect(() => {
    const wasSearching = (prevSearchRef.current || "").trim().length > 0;
    const isCleared = (search || "").trim().length === 0;
    prevSearchRef.current = search;
    if (wasSearching && isCleared) {
      setPage(1);
      refetchListing();
    }
  }, [search, refetchListing]);

  React.useEffect(() => {
    const handleDealflowShortlistComplete = () => {
      setIsAIShortlistProcessing(false);
      setPage(1);
      selectAll && setSelectAll(false);
      setSelectedIds(new Set());
      refetchListing();
    };

    registerBatchCompletionCallback('dealflow_shortlist', handleDealflowShortlistComplete);

    return () => {
      unregisterBatchCompletionCallback('dealflow_shortlist');
    };
  }, [refetchListing]);

  const [isMobile, setIsMobile] = React.useState(false);
  React.useEffect(() => {
    if (typeof window !== "undefined") {
      const userAgent = navigator.userAgent || navigator.vendor || window.opera;
      const isMobileDevice =
        /Android|iPhone|iPad|iPod/i.test(userAgent) && window.innerWidth < 768; // Extra check for screen width
      setIsMobile(isMobileDevice);
    }
  }, []);


  const {
    mutateAsync: FetchStatusAsync,
    status: fetchStatusStatus,
    error: fetchStatusError,
    isLoading: isUpdatingFetchStatus,
    data: fetchStatusResponse,
  } = FetchInterestFeedbackStatus();

  const { data: currencyList, isLoading: isLoadingCurrency } =
    FetchAllCurrencyLists();


  const [isEnabledInterest, setIsEnabledInterest] = React.useState(false);
  const [isEnabledFeedback, setIsEnabledFeedback] = React.useState(false);
  const [showAlert, setShowAlert] = React.useState(false)
  const [alertMessage, setAlertMessage] = React.useState(null)
  const [alertHeading, setAlertHeading] = React.useState(null)

  // React.useEffect(() => {
  //     if (fetchStatusResponse && fetchStatusResponse?.data?.statusCode == 200) {
  //         setIsEnabledInterest(fetchStatusResponse?.data?.investorInfo == null)
  //         setIsEnabledFeedback(fetchStatusResponse?.data?.feedback == null)
  //     } else {
  //         // fetchStatusResponse?.data?.message && toast.error(<CustomToast message={fetchStatusResponse?.data?.message} style={{ padding: "0px 15px" }} closeIcon={true} />, {
  //         //     duration: 4000,
  //         //     position: "top-right",
  //         //     style: {
  //         //         padding: "15px 30px",
  //         //     },
  //         // });
  //     }
  // }, [fetchStatusResponse?.data?.statusCode]);

  // console.log(transformedData?.data, "startupListingData")

  React.useEffect(() => {
    let count = 0;
    if (!isLoadingStartupListing && count == 0) {
      if (transformedData?.count && transformedData?.count == 0 && value === "invited") {
        if (search?.trim()?.length === 0 && Object.keys(queryParams)?.length === 0)
          handleInviteStartupPopupOpen()
        count = 1;
      }
    }
  }, [isLoadingStartupListing, value, transformedData])

  // Memoized Tooltip Icon Component
  const MemoizedTooltipIcon = React.memo(({ title, icon, onClick }) => (
    <Tooltip title={title}>
      <IconButton onClick={onClick}>{icon}</IconButton>
    </Tooltip>
  ));

  const handleMainTabChange = (event, newValue) => {
    // console.log("value", newValue)
    setMainTabValue(newValue);
    Cookies.set("pipeline", JSON.stringify(newValue), { expires: 1 });
    // Cookies.set("startups_status", JSON.stringify(newValue), { expires: 1 });
    setPage(1);
    setTransformedData({
      ...transformedData,
      count: 0
    })
  };

  const [selectAll, setSelectAll] = useState(false);

  const handleTabChange = (event, newValue) => {
    // console.log("value", newValue)
    setValue(newValue);
    setSelectAll(false);
    setSelectedIds(new Set());
    Cookies.set("status", JSON.stringify(newValue), { expires: 1 });
    setPage(1);
    setTransformedData({
      ...transformedData,
      count: 0
    })
  };


  const [openInvitedConfirmationPopup, setOpenInvitedConfirmationPopup] = React.useState(false);

  const handleInvitedConfirmationPopupClose = () => {
    setOpenInvitedConfirmationPopup(false);
    setCurrentRow(null);
  }

  const handleInvitedConfirmationPopupOpen = ({ row }) => {
    setOpenInvitedConfirmationPopup(true);
    setCurrentRow(row?.original);
  }

  const handleSubmissionInvited = ({ row }) => {
    // setCurrentRow(row);
    // console.log(row);
    // updateStartupStatusAsync({
    //     "startup_id": "66f285de9ce0f2c5615f20e5",
    //     "status_code": "Inviteded"
    // }).then((response) => {
    //     refetchListing();
    //     handleInvitedConfirmationPopupClose();
    // }).catch((error) => {

    // })

    updateStartupStatusAsync({
      payload: {
        "status": "invited"
      }
      , pipeline_id: currentRow?.pipeline_id
    }).then((response) => {
      addToast("Moved to Invited", "success")
      refetchListing();
      handleInvitedConfirmationPopupClose();
    }).catch((error) => {

    })
  }

  const RowActions = ({ row, iconsColor = theme.palette.customColors.indigo700, index, slot = 'all' }) => {
    // `slot` lets the mobile card render pieces of this action cluster in different
    // places: 'contact' = just the Send Message icon (bottom-left), 'menu' = just the
    // three-dot menu (top-right). 'all' (default, desktop) renders everything as before.
    // View Profile (open-in-new) is desktop-only now, so it shows only for 'all'.
    const showAll = slot === 'all';
    const showContact = slot === 'all' || slot === 'contact';
    const showMenu = slot === 'all' || slot === 'menu';
    // return <>

    // </>
    // console.log(row, "row")

    const [anchorEl, setAnchorEl] = React.useState(null);
    const openMenu = Boolean(anchorEl);
    const handleClickMenu = (event, index) => {
      setAnchorEl(event.currentTarget);
      // setCurrentIndex(index)
      // console.log(event.currentTarget,"re")
    };
    const handleCloseMenu = (event) => {
      // console.log(event,"event")
      setAnchorEl(null);
      // setCurrentIndex(null);
    };

    const [anchorConnectEl, setAnchorConnectEl] = React.useState(null);
    const openConnectMenu = Boolean(anchorConnectEl);
    const handleClickConnectMenu = (event, index) => {
      setAnchorConnectEl(event.currentTarget);
      // setCurrentIndex(index)
      // console.log(event.currentTarget,"re")
    };
    const handleCloseConnectMenu = (event) => {
      // console.log(event,"event")
      setAnchorConnectEl(null);
      // setCurrentIndex(null);
    };

    const phone_number = row?.original?.phone_code + row?.original?.mobile_number

    // switch (value) {
    //     case "new": return <>
    const logs = row?.original?.logs;
    return <>
      {
        showAll && logs && logs?.length > 0 && (
          <MemoizedTooltipIcon title={
            <Box sx={{ whiteSpace: 'pre-wrap', fontSize: '0.85rem' }}>
              {(() => {
                const lastLog = logs?.[logs?.length - 1];
                return lastLog ? (
                  <Box sx={{ mb: 1, display: "grid" }}>
                    <Typography variant="caption" sx={{ fontWeight: 600 }}>Action: {lastLog?.action}</Typography>
                    <Typography variant="caption">Reason: {lastLog?.reasoning}</Typography>
                    <Typography variant="caption" sx={{ fontSize: '0.75rem', opacity: 0.8 }}>
                      Date: {new Date(lastLog?.timestamp)?.toLocaleDateString('en-GB', { day: '2-digit', month: 'short', year: 'numeric' })}
                    </Typography>
                  </Box>
                ) : null;
              })()}
            </Box>
          }
            icon={<Info sx={{ color: theme.palette.customColors.indigo600, cursor: 'pointer' }} />}
          />
        )
      }
      {showContact && <MemoizedTooltipIcon title="Send Message" onClick={(e) => handleClickConnectMenu(e)} icon={
        // <MessageOutlined
        <MessageOutlined sx={{
          color: theme.palette.customColors.indigo600
        }}
        />
      }
      // <ConnectWithoutContact sx={{
      //     color: theme.palette.customColors.indigo600
      // }} />}
      />}
      {showContact && <Menu
        anchorEl={anchorConnectEl}
        id="connect-menu"
        open={openConnectMenu}
        aria-controls={openConnectMenu ? 'fade-menu' : 'fade-menu'}
        aria-haspopup="true"
        aria-expanded={openConnectMenu ? 'true' : 'false'}
        onClose={handleCloseConnectMenu}
        onClick={handleCloseConnectMenu}
        PaperProps={{
          elevation: 0,
          sx: {
            overflow: 'visible',
            filter: 'drop-shadow(0px 2px 8px rgba(0,0,0,0.32))',
            mt: 1.5,
            padding: "12px",
            borderRadius: "8px",
            "& > ul.MuiList-root": { padding: "0 !important" },
            bgcolor: theme.palette.customColors.g400,
            color: theme.palette.customColors.whiteBG,
            // '&::before': {
            //     content: '""',
            //     display: 'block',
            //     position: 'absolute',
            //     top: 1,
            //     right: 5,
            //     width: 10,
            //     height: 10,
            //     bgcolor: theme.palette.customColors.g900,
            //     transform: 'translateY(-50%) rotate(45deg)',
            //     zIndex: 0,
            // },
          },
        }}
        transformOrigin={{ horizontal: 'right', vertical: 'top' }}
        anchorOrigin={{ horizontal: 'right', vertical: 'center' }}
      >
        {/* {value === "invited" && <> */}
        <MenuItem
          disableRipple sx={{ borderBottom: `1px solid ${theme.palette.customColors.g700}`, padding: '0.625rem 1rem' }} onClick={() => {
            // if (row?.original?._id) {
            //     Cookies.set("startup_id", row?.original?._id); navigate(location ? `view-profile` : `/deal-flow/view-profile`)
            // }
            // if (row?.original?.email) {

            // }
          }}>
          <a href={`mailto:${row?.original?.email}`} rel="noopener noreferrer" style={{ textDecoration: 'none', color: "inherit", display: "flex", alignItems: 'center' }} >
            <EmailOutlined sx={{ mr: 1 }} /> Email
          </a>
        </MenuItem>
        {/* WhatsApp option hidden in Deal Flow - only Email is shown on the Send Message menu.
        <MenuItem disableRipple sx={{ borderBottom: `0px solid ${theme.palette.customColors.g700}`, padding: '0.625rem 1rem' }} onClick={() => {
          // if (row?.original?._id) {
          //     Cookies.set("startup_id", row?.original?._id); navigate(location ? `view-profile` : `/deal-flow/view-profile`)
          // }
        }}>
          <a href={isMobile ? `https://wa.me/${phone_number}` : `https://web.whatsapp.com/send?phone=${phone_number}`} target="_blank" rel="noopener noreferrer" style={{ textDecoration: 'none', color: "inherit", display: "flex", alignItems: 'center' }} >
            <WhatsApp sx={{ mr: 1 }} /> WhatsApp
          </a>
        </MenuItem>
        */}

        {/* </> */}
        {/* } */}
        {/* {value == "rejected" && <MenuItem disableRipple sx={{ borderBottom: `0px solid ${theme.palette.customColors.g700}`, padding: '0.625rem 1rem' }} onClick={() => handleShortlistConfirmationPopupOpen({ row })}>
                  
                    Move to Shortlisted
                </MenuItem>} */}
      </Menu>}
      {showMenu && <><IconButton
        sx={{ borderRadius: "4px" }}
        id={`more-details-button-${index}`}
        size="small"
        aria-controls={openMenu ? 'more-details-menu' : undefined}
        aria-haspopup="true"
        aria-expanded={openMenu ? 'true' : undefined}
        onClick={(e) => handleClickMenu(e)}
        centerRipple={false}
      >
        <MoreOptionsIcon />
      </IconButton>
      {/* TO be reverted After Demo */}
      {/* {value !== "rejected" &&  */}
      <Menu
        anchorEl={anchorEl}
        id="account-menu"
        open={openMenu}
        aria-controls={openMenu ? 'fade-menu' : 'fade-menu'}
        aria-haspopup="true"
        aria-expanded={openMenu ? 'true' : 'false'}
        onClose={handleCloseMenu}
        onClick={handleCloseMenu}
        PaperProps={{
          elevation: 0,
          sx: {
            overflow: 'visible',
            filter: 'drop-shadow(0px 2px 8px rgba(0,0,0,0.32))',
            mt: 1.5,
            padding: "12px",
            borderRadius: "8px",
            "& > ul.MuiList-root": { padding: "0 !important" },
            bgcolor: theme.palette.customColors.g400,
            color: theme.palette.customColors.whiteBG,
            // '&::before': {
            //     content: '""',
            //     display: 'block',
            //     position: 'absolute',
            //     top: 1,
            //     right: 5,
            //     width: 10,
            //     height: 10,
            //     bgcolor: theme.palette.customColors.g900,
            //     transform: 'translateY(-50%) rotate(45deg)',
            //     zIndex: 0,
            // },
          },
        }}
        transformOrigin={{ horizontal: 'right', vertical: 'top' }}
        anchorOrigin={{ horizontal: 'right', vertical: 'center' }}
      >
        {/* {value !== "rejected" && <>
                    {value !== "interested" && hasPermission("startups", "submit_interest", userPermissions) && <MenuItem disableRipple sx={{ borderBottom: `1px solid ${theme.palette.customColors.g700}`, padding: '0.625rem 1rem' }} onClick={() => handleShowInterestPopupOpen({ row })}>

                        Submit Interest
                    </MenuItem>}
                    {value === "in-progress" && hasPermission("startups", "manage", userPermissions) && <MenuItem disableRipple sx={{ borderBottom: `1px solid ${theme.palette.customColors.g700}`, padding: '0.625rem 1rem' }} onClick={() => handleShortlistConfirmationPopupOpen({ row })}>

                        Move to Shortlisted
                    </MenuItem>}
                    {value === "interested" && hasPermission("startups", "manage", userPermissions) && <MenuItem disableRipple sx={{ borderBottom: `1px solid ${theme.palette.customColors.g700}`, padding: '0.625rem 1rem' }} onClick={() => handleInProgressConfirmationPopupOpen({ row })}>

                        Move to Selected
                    </MenuItem>}
                    {hasPermission("startups", "manage", userPermissions) && <MenuItem disableRipple sx={{ borderBottom: `1px solid ${theme.palette.customColors.g700}`, padding: '0.625rem 1rem' }} onClick={() => handleRejectConfirmationPopupOpen({ row })}>

                        Move to Rejected
                    </MenuItem>}
                    {hasPermission("startups", "submit_feedback", userPermissions) && <MenuItem disableRipple sx={{ borderBottom: `1px solid ${theme.palette.customColors.g700}`, padding: '0.625rem 1rem' }} onClick={() => handleFeedbackPopupOpen({ row })}>

                        Submit Feedback
                    </MenuItem>}
                    <MenuItem disableRipple sx={{ borderBottom: `0px solid ${theme.palette.customColors.g700}`, padding: '0.625rem 1rem' }} onClick={() => {
                        if (row?.original?._id) {
                            Cookies.set("startup_id", row?.original?._id); navigate(location ? `view-profile` : `/deal-flow/view-profile`)
                        }
                    }}>
                        View Details
                    </MenuItem>
                </>} */}

        {/* TO Be Reverted After Demo */}
        {/* {value !== "rejected" && <> */}
        {/* {value !== "interested" && hasPermission("startups", "submit_interest", userPermissions) &&  */}

        {/* } */}
        {/* {value === "in-progress" && hasPermission("startups", "manage", userPermissions) && */}
        {/* {value !== "invited" && <MenuItem disableRipple sx={{ borderBottom: `1px solid ${theme.palette.customColors.g700}`, padding: '0.625rem 1rem' }} onClick={() => handleInvitedConfirmationPopupOpen({ row })}>

                    Move to New
                </MenuItem>}

                {value !== "interested" && <MenuItem disableRipple sx={{ borderBottom: `1px solid ${theme.palette.customColors.g700}`, padding: '0.625rem 1rem' }} onClick={() => handleShortlistConfirmationPopupOpen({ row })}>

                    Move to Shortlisted
                </MenuItem>} */}
        {/* } */}
        {/* {value === "interested" && hasPermission("startups", "manage", userPermissions) &&  */}
        {/* {value !== "in-progress" && <MenuItem disableRipple sx={{ borderBottom: `1px solid ${theme.palette.customColors.g700}`, padding: '0.625rem 1rem' }} onClick={() => handleInProgressConfirmationPopupOpen({ row })}>

                    Move to Selected
                </MenuItem>} */}
        {/* } */}
        {/* {hasPermission("startups", "manage", userPermissions) &&  */}
        {/* {value !== "rejected" && <MenuItem disableRipple sx={{ borderBottom: `1px solid ${theme.palette.customColors.g700}`, padding: '0.625rem 1rem' }} onClick={() => handleRejectConfirmationPopupOpen({ row })}>

                    Move to Rejected
                </MenuItem>} */}
        {/* } */}
        {/* {hasPermission("startups", "submit_feedback", userPermissions) &&  */}
        {pipelineTabsArray?.length > 1 && <MenuItem disableRipple sx={{ borderBottom: `1px solid ${theme.palette.customColors.g700}`, padding: '0.625rem 1rem' }} onClick={() => handleOpenMoveToSelectedPipeline({ row })}>

          Move to Pipeline
        </MenuItem>}
        {/* AI Shortlist removed from the per-row actions menu (still available in the bulk Actions menu).
        {hasPermission("startups", "manage", userPermissions) && mainTabValue === "All" && isInNewStatus && <MenuItem disableRipple sx={{ borderBottom: `1px solid ${theme.palette.customColors.g700}`, padding: '0.625rem 1rem', '&:hover': { backgroundColor: 'rgba(124, 58, 237, 0.08)' }, fontWeight: 600 }} onClick={() => { handleAIShortlistPopupOpen(); handleCloseMenu(); }} disabled={isAIShortlistProcessing || isShortlisting}>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.75 }}>
            <Box sx={{ color: 'rgba(255, 193, 7, 0.8)' }}>
              {isAIShortlistProcessing || isShortlisting ? <CircularProgress size={14} sx={{ color: 'inherit' }} /> : <SparklesIcon width={14} height={14} />}
            </Box>
            AI Shortlist
          </Box>
        </MenuItem>}
        */}
        <MenuItem disableRipple sx={{ borderBottom: `1px solid ${theme.palette.customColors.g700}`, padding: '0.625rem 1rem' }} onClick={() => handleShowInterestPopupOpen({ row })}>

          Submit Interest
        </MenuItem>
        <MenuItem disableRipple sx={{ borderBottom: `1px solid ${theme.palette.customColors.g700}`, padding: '0.625rem 1rem' }} onClick={() => handleFeedbackPopupOpen({ row })}>

          Submit Feedback
        </MenuItem>
        {row?.original?.slug && row?.original?.slug != null && (String(row?.original?.slug)?.length > 0) &&
        <MenuItem disableRipple sx={{ borderBottom: `1px solid ${theme.palette.customColors.g700}`, padding: '0.625rem 1rem' }} onClick={() => {
          window.open(navigateToDomain("main", ("startup/" + row?.original?.slug)))
        }}>
          View Profile
        </MenuItem>}
        {/* } */}
        <MenuItem disableRipple sx={{ borderBottom: `0px solid ${theme.palette.customColors.g700}`, padding: '0.625rem 1rem' }} onClick={() => {
          if (row?.original?._id) {
            Cookies.set("startup_id", row?.original?._id); navigate(location ? `view-profile` : `/deal-flow/view-profile`)
          }
        }}>
          View Details
        </MenuItem>
        {/* </>} */}
      </Menu></>}
      {/* } */}
    </>
  }

  const NewColumns = [
    { Header: 'Name', accessor: 'name', minWidth: 300, align: 'start', fixed: true },
    // { Header: 'Email', accessor: 'email', minWidth: 150, align: 'start' },
    { Header: 'Location', accessor: 'location', minWidth: 100, align: 'center' },
    { Header: 'Stage', accessor: 'stage', minWidth: 100, align: 'center' },
    { Header: 'Round Size', accessor: 'totalRoundSize', minWidth: 150, align: 'center' },
    { Header: 'Category/Sector', accessor: 'category_sub_sector', minWidth: 100, align: 'center' },
    { Header: 'Status', accessor: 'pipeline_status_value', minWidth: 100, align: 'center' },
    { Header: 'Date', accessor: 'invited_date', minWidth: 100, align: 'center' },
    // { Header: 'Interested Amount', accessor: 'formatted_interested_amount', minWidth: 150, align: 'center', tooltip: 'interested_amount' },
    { Header: 'Pitch Deck', accessor: 'pitch_deck', minWidth: 100, align: 'center' },
    { Header: 'Links', accessor: 'links', minWidth: 100, align: 'center' },
    // { Header: 'Funding round', accessor: 'funding_round', minWidth: 100, align: 'center' },
    { Header: 'Actions', accessor: 'actions', minWidth: 100, align: 'center' }
  ];

  const ShortlistedColumns = [
    { Header: 'Name', accessor: 'name', minWidth: 300, align: 'start', fixed: true },
    // { Header: 'Email', accessor: 'email', minWidth: 150, align: 'start' },
    { Header: 'Location', accessor: 'location', minWidth: 100, align: 'center' },
    { Header: 'Stage', accessor: 'stage', minWidth: 100, align: 'center' },
    { Header: 'Round Size', accessor: 'totalRoundSize', minWidth: 150, align: 'center' },
    { Header: 'Pitch Reel', accessor: 'pitch_reels', minWidth: 150, align: 'center' },
    { Header: 'Category/Sector', accessor: 'category_sub_sector', minWidth: 100, align: 'center' },
    { Header: 'Status', accessor: 'pipeline_status_value', minWidth: 100, align: 'center' },
    { Header: 'Date', accessor: 'interested_shown_date', minWidth: 100, align: 'center' },
    // { Header: 'Interested Amount', accessor: 'formatted_interested_amount', minWidth: 150, align: 'center' },
    { Header: 'Interested Amount', accessor: 'formatted_interested_amount', minWidth: 150, align: 'center', tooltip: 'interested_amount' },
    { Header: 'Pitch Deck', accessor: 'pitch_deck', minWidth: 100, align: 'center' },
    { Header: 'Links', accessor: 'links', minWidth: 100, align: 'center' },
    // { Header: 'Funding round', accessor: 'funding_round', minWidth: 100, align: 'center' },
    { Header: 'Actions', accessor: 'actions', minWidth: 100, align: 'center' }
  ]

  const InProgressColumns = [
    ...(
      hasPermission("startups", "manage", userPermissions)
        ? [{
          Header: "checkbox",
          accessor: "checkbox",
          fixed: true,   // 👈 add this
          align: "center",
          left: 0,
          hidden: false,
          minWidth: 10,
          disabled: isAIShortlistProcessing || isShortlisting
        }] : []),
    {
      Header: "Name",
      accessor: "name",
      minWidth: 300,
      align: "start",
      fixed: true,
      // left: 0,
      left:
        hasPermission("startups", "manage", userPermissions)
          ? 50 : 0,
      hidden: false,
    },
    {
      Header: "Founder Name", accessor: "founder_name", minWidth: 150, align: "center",
    },
    {
      Header: "Source", accessor: "source", minWidth: 100, align: "center", showInCard: false,
    },
    // { Header: 'Email', accessor: 'email', minWidth: 150, align: 'start' },
    ...(
      hasPermission("pitch_reels", "view", userPermissions)
        ? [{ Header: 'Reel', accessor: 'pitch_reels', minWidth: 150, align: 'center', cardIcon: true }]
        : []),
    { Header: 'Location', accessor: 'location', minWidth: 100, align: 'center' },
    { Header: 'Stage', accessor: 'stage', minWidth: 100, align: 'center' },
    { Header: 'Round Size', accessor: 'totalRoundSize', minWidth: 150, align: 'center' },
    { Header: 'Category/Sector', accessor: 'category_sub_sector', minWidth: 100, align: 'center' },
    ...(
      hasPermission("startups", "manage", userPermissions)
        ? [{ Header: 'Status', accessor: 'pipeline_status_value', minWidth: 100, align: 'center', cardFooter: true }]
        : []),
    // { Header: 'Date', accessor: 'in_progress_date', minWidth: 100, align: 'center' },
    { Header: 'Date', accessor: 'pipelineUpdatedDate', minWidth: 100, align: 'center' },
    // { Header: 'Interested Amount', accessor: 'formatted_interested_amount', minWidth: 150, align: 'center' },
    { Header: 'Interested Amount', accessor: '_interested_amount', minWidth: 150, align: 'center', showInCard: false },
    { Header: 'Allocated Amount', accessor: '_allocated_amount', minWidth: 150, align: 'center', showInCard: false },
    { Header: 'Pitch Deck', accessor: 'pitch_deck', minWidth: 100, align: 'center', cardIcon: true },
    { Header: 'Links', accessor: 'links', minWidth: 100, align: 'center', cardFooter: true, showInCard: false },
    // { Header: 'Funding round', accessor: 'funding_round', minWidth: 100, align: 'center' },
    { Header: 'Actions', accessor: 'actions', minWidth: 100, align: 'center' }
  ]

  const RejectedColumns = [
    { Header: 'Name', accessor: 'name', minWidth: 300, align: 'start', fixed: true },
    // { Header: 'Email', accessor: 'email', minWidth: 150, align: 'start' },
    { Header: 'Location', accessor: 'location', minWidth: 100, align: 'center' },
    { Header: 'Stage', accessor: 'stage', minWidth: 100, align: 'center' },
    { Header: 'Status', accessor: 'pipeline_status_value', minWidth: 100, align: 'center' },
    { Header: 'Round Size', accessor: 'totalRoundSize', minWidth: 150, align: 'center' },
    { Header: 'Category/Sector', accessor: 'category_sub_sector', minWidth: 100, align: 'center' },
    { Header: 'Date', accessor: 'investor_rejected_date', minWidth: 100, align: 'center' },
    { Header: 'Pitch Deck', accessor: 'pitch_deck', minWidth: 100, align: 'center' },
    { Header: 'Links', accessor: 'links', minWidth: 100, align: 'center' },
    // { Header: 'Funding round', accessor: 'funding_round', minWidth: 100, align: 'center' },
    { Header: 'Actions', accessor: 'actions', minWidth: 100, align: 'center' }
  ]

  const columns = InProgressColumns;
  // Saved layout wins; otherwise the compact row set, with the rest shown in the expanded panel.
  const hiddenColumns = fetchedSettingFromBackend?.table_customization?.hidden_columns ?? DEFAULT_HIDDEN_COLUMNS;
  const [selectedIds, setSelectedIds] = useState(new Set()); // Ensure it's a Set

  const { mutateAsync: updatePipelineFlow, isLoading: isUpdatingPipelineFlow } = UpdatePipelineFlowName()
  const { mutateAsync: updateDealFlow, isLoading: isUpdatingDealFlow } = UpdateDealFlowName()
  // const { mutateAsync: deletePiplineFlow, isLoading: isDeletingPipelineFlow } = DeletePipelineFlow()
  // const { mutateAsync: deletePipelineStatus, isLoading: isDeletingPipelineStatus } = DeletePipelineStatus({ investor_id })

  const { mutateAsync: createNewPipelineFlow, isLoading: isCreatingPipeline } = CreatePipeline({ investor_id })

  const [openCreatePipelinePopup, setOpenCreatePipelinePopup] = React.useState(false);

  const handleCloseCreatePipelinePopup = () => {
    setOpenCreatePipelinePopup(false)
  }

  const handleOpenCreatePipelinePopup = () => {
    setOpenCreatePipelinePopup(true)
  }

  const handleSubmissionCreatePipline = ({ payload }) => {
    createNewPipelineFlow({ ...payload }, {
      onSuccess: (response) => {
        if (response?.data?.statusCode === 201) {
          // console.log(response, "response")
          const res = response.data.data
          setPipelinesData({
            data: [...pipelinesData.data, {
              label: res?.name,
              value: res?._id,
              _id: res?._id,
              display_order: res?.display_order,
              is_deletable: true,
              slug: res?.slug
            }].sort((a, b) => a.display_order - b.display_order)
          })
          response.data.data._id && setMainTabValue(response.data.data._id);
          // refetchListing();
          // refetchPipelineTabs()
          // refetchStatusTabs()
          handleCloseCreatePipelinePopup();
        }
        else if (response?.data?.statusCode === 409) {
          addToast("A pipeline with that name already exists. Enter a unique name.", "error")
        }
        else {
          addToast(response?.data?.message, "error")
        }
      },
      onError: (errorResponse) => {
        // refetchListing();
      }
    })
  }

  const { mutateAsync: createNewDealFlow, isLoading: isCreatingDealFlow } = CreateDealFlow()

  const [openCreateDealPopup, setOpenCreateDealPopup] = React.useState(false);

  const handleCloseCreateDealPopup = () => {
    setOpenCreateDealPopup(false)
  }

  const handleOpenCreateDealPopup = () => {
    setOpenCreateDealPopup(true)
  }

  const handleSubmissionCreateDealFlow = (props) => {
    let payload = {
      "investorId": investor_id,
      // "statusId": "6824871b4d11e25fd4e890c9",
      "newStatus": props?.status
    }
    // console.log(props, payload, "payload")
    createNewDealFlow({ ...payload }, {
      onSuccess: (response) => {
        if (response?.data?.statusCode === 200) {
          // console.log(response.data.data._id, "repoons")
          // refetchListing();
          // refetchStatusTabs();

          const res = response.data.data
          setPipelineStatusesData({
            data: [...pipelineStatusesData.data, {
              label: res.status,
              value: res._id,
              _id: res._id,
              display_order: res.display_order,
              is_deletable: true,
            }].sort((a, b) => a.display_order - b.display_order)
          })
          response.data.data._id && setValue(response.data.data._id);
          handleCloseCreateDealPopup();
        }
        else if (response?.data?.statusCode === 409) {
          addToast("A status with that name already exists. Enter a unique name.", "error")
        }
        else {
          addToast(response?.data?.message, "error")
        }
      },
      onError: () => {
        refetchListing();
      }
    })
  }

  const [openSettingsModal, setOpenSettingsModal] = React.useState(false);
  const [settingsType, setSettingsType] = React.useState(null)

  const handleOpenPipelineFlowSettingsModal = () => {
    setSettingsType("pipeline");
    setOpenSettingsModal(true);
  }

  const handleOpenDealFlowSettingsModal = () => {
    setSettingsType("status");
    setOpenSettingsModal(true);
  }

  const handleCloseSettingsModal = () => {
    setOpenSettingsModal(false);
    setSettingsType(null);
    // refetchPipelineTabs();
    // refetchStatusTabs();
  }

  const onEditStatus = (props) => {
    // const payload = {
    //     "deal_flow_name": props?.label,
    //     "deal_flow_id": props?.deal_flow_id,
    //     "investor_id": investor_id
    // }

    let payload = {
      "investorId": investor_id,
      "statusId": props?.status_id,
      "newStatus": props?.label
    }

    if (props?.label !== statusTabsArray?.find(item => item?.value === props?.deal_flow_id)?.label)
      createNewDealFlow(payload, {
        onSuccess: () => {
          const updatedStatusTabsArray = statusTabsArray
            .map(item => {
              if (item?.value === props?.status_id) {
                // Found the object to update, return a new object with the changes
                return {
                  ...item, // Keep existing properties
                  label: props?.label, // Update the label
                  status: props?.label, // Update the status (if needed, otherwise remove)
                  // Add any other properties you want to update
                };
              }
              // Not the object we're looking for, return it unchanged
              return item;
            })
            .sort((a, b) => a?.display_order - b?.display_order); // Sort the updated array

          setPipelineStatusesData({
            data: updatedStatusTabsArray
          });
          // refetchListing();
          // refetchStatusTabs();
        }
      })
    // console.log(payload)
  }

  const onEditPipeline = (props) => {
    const payload = {
      "name": props?.label,
    }
    if (props?.label !== pipelineTabsArray?.find(item => item?.value === props?.pipeline_id)?.label)
      updatePipelineFlow({ "pipeline_id": props?.pipeline_id, investor_id: investor_id, payload: { ...payload } }, {
        onSuccess: () => {
          // refetchPipelineTabs();
          const updatedPipelinesTabsArray = pipelineTabsArray?.filter(item => item?.value !== "All")
            .map(item => {
              if (item?.value === props?.pipeline_id) {
                // Found the object to update, return a new object with the changes
                return {
                  ...item, // Keep existing properties
                  label: props?.label, // Update the label
                  status: props?.label, // Update the status (if needed, otherwise remove)
                  // Add any other properties you want to update
                };
              }
              // Not the object we're looking for, return it unchanged
              return item;
            })
            .sort((a, b) => a?.display_order - b?.display_order); // Sort the updated array

          setPipelinesData({
            data: updatedPipelinesTabsArray
          });
        }
      })
    // console.log(payload)
  }

  // const [openDeletePipelineFlowPopup, setOpenDeletePipelineFlowPopup] = React.useState(false)
  // const [openDeletePipelineStatusPopup, setOpenDeletePipelineStatusPopup] = React.useState(false)

  // const onDeletePipelineStatus = ({ _id, name }) => {
  //     // setCurrentRow();
  //     setCurrentRow({ _id: _id, name });
  //     setOpenDeletePipelineStatusPopup(true)
  // }

  // const onDeletePipeline = ({ _id, name }) => {
  //     // setCurrentRow();
  //     setCurrentRow({ _id: _id, name });
  //     setOpenDeletePipelineFlowPopup(true)
  // }


  // const handleCloseDeletePipelineFlowPopup = () => {
  //     setOpenDeletePipelineFlowPopup(false);
  //     setCurrentRow(null);
  // }

  // const handleCloseDeletePipelineStatusPopup = () => {
  //     setOpenDeletePipelineStatusPopup(false);
  //     setCurrentRow(null);
  // }

  // const handleDeletePipelineFlow = () => {
  //     // console.log(currentRow, "delete");
  //     deletePiplineFlow({ pipeline_id: currentRow?._id }, {
  //         onSuccess: (response) => {
  //             if (response.data.statusCode === 200) {
  //                 refetchListing()
  //                 refetchPipelineTabs()
  //                 mainTabValue === currentRow?._id && setMainTabValue("All");
  //                 handleCloseDeletePipelineFlowPopup();
  //                 addToast("Pipeline Deleted!", "success")
  //             }
  //             else {
  //                 addToast(response.data.message, "error")
  //             }
  //         },
  //         onError: () => {
  //             // handleCloseDeletePipelineFlowPopup()
  //         }
  //     })
  // }

  // const handleDeletePipelineStatus = () => {
  //     // console.log({ statusId: currentRow?._id }, "currentRow")
  //     deletePipelineStatus({ statusId: currentRow?._id }, {
  //         onSuccess: (response) => {
  //             if (response.data.statusCode === 200) {
  //                 refetchListing()
  //                 refetchStatusTabs()
  //                 handleCloseDeletePipelineStatusPopup();
  //                 addToast("Status Deleted!", "success")
  //             }
  //             else {
  //                 addToast(response.data.message, "error")
  //             }
  //         },
  //         onError: () => {
  //             //handleCloseDeletePipelineStatusPopup()
  //         }
  //     })
  // }

  const filteredStatuses = pipelineStatusesData?.data;

  // const filteredStatuses = statusTabsArray?.filter(item => item?.value !== "All");

  // Memoized Data Transformation
  const useFormattedData = (transformedData) => {
    return React.useMemo(() => {
      return transformedData?.data && transformedData?.data?.length > 0
        ? transformedData?.data?.map((item) => {
          // console.log(item?.interested_amount, "item?.interested_amount")
          const pipeline_details = item?.currency_id ? {
            interested_amount: item?.interested_amount ?? null,
            _interested_amount:
              Boolean(item?.interested_amount) ?
                <Tooltip title={amountInWords(item?.interested_amount, currencyList?.find(item => item?._id === item?.currency_id)?.code)}>
                  <Typography>
                    {currencyList?.find(el => el?._id === item?.currency_id)?.code}{convertCurrencyAmountRange(item?.interested_amount, currencyList?.find(el => el?._id === item?.currency_id)?.name, 0)}
                  </Typography>
                </Tooltip>
                : <Box onClick={() => { handleShowInterestPopupOpen({ row: item }) }} display={"flex"} alignItems={"center"} justifyContent={"center"} sx={{ textDecoration: "underline", textUnderlineOffset: '5px', textDecorationColor: "#3538CD", cursor: 'pointer' }}>
                  <Add style={{ width: 20, height: 20, color: "#3538CD" }} />
                  <Typography fontSize={"0.9rem"} color={"#3538CD"}> Add </Typography>
                </Box>,
            // <Tooltip title={amountInWords(item?.interested_amount, currencyList?.find(item => item?._id === item?.currency_id)?.code)}>
            // </Tooltip> 
            allocated_amount: item?.allocated_amount ?? null,
            _allocated_amount:
              item?.allocated_amount ?
                `${currencyList?.find(el => el?._id === item?.currency_id)?.code}${convertCurrencyAmountRange(item?.allocated_amount, currencyList?.find(el => el?._id === item?.currency_id)?.name, 0)}`
                : "-",
            // <Tooltip title={amountInWords(item?.allocated_amount, currencyList?.find(item => item?._id === item?.currency_id)?.code)}>
            // </Tooltip>
          } : {
            interested_amount: false,
            _interested_amount: <Box onClick={() => { handleShowInterestPopupOpen({ row: item }) }} display={"flex"} alignItems={"center"} justifyContent={"center"} sx={{ textDecoration: "underline", textUnderlineOffset: '5px', textDecorationColor: "#3538CD", cursor: 'pointer' }}>
              <Add style={{ width: 20, height: 20, color: "#3538CD" }} />
              <Typography fontSize={"0.9rem"} color={"#3538CD"}> Add </Typography>
            </Box>,
            // <Tooltip title={amountInWords(item?.interested_amount, currencyList?.find(item => item?._id === item?.currency_id)?.code)}>
            // </Tooltip> 
            allocated_amount: item?.allocated_amount ?? null,
            _allocated_amount: "-",
          }

          const location = [
            item?.city_id?.name,
            // item?.state_id?.name,
            item?.country_id?.name
          ]
            .filter(Boolean)
            .join(', ') || '-';
          // console.log(pipeline_details?.interested_amount, pipeline_details?.allocated_amount, "amount")
          // console.log(item, "pipeline_details",item?.currency_id)
          // console.log(item, "pipeline_details",currencyList?.find(el => el?._id === item?.currency_id)?.name);

          const logs = item?.ai_shortlist_log && Array.isArray(item?.ai_shortlist_log) && item?.ai_shortlist_log?.length > 0 ? [item?.ai_shortlist_log[item?.ai_shortlist_log?.length - 1]] : []
          return ({
            ...item,
            ...pipeline_details,
            pitch_reels: item?.video_pitch ? <PitchReelButton item={item} statuses={statusTabsArray} onOpenReel={handleOpenReel} /> : "-",
            // pitch_reel: item?.video_pitch ? <IconButton
            // sx={{
            //   background: "rgba(0, 0, 0, 0.04)"
            // }}
            // onClick={() => {
            //   window.open(`/pitch-reels/${item?.pipeline_status === "invited" ?  "deal-flow": "selected"}?st=` + item?._id)
            // }} >
            //   <PlayArrow sx={{ color: theme.palette.customColors.indigo600 }} />
            // </IconButton> : "-",
            name: item?.startup_name,
            founder_name: item?.name,
            source: formatDealSource(item?.source),
            pipeline_status_value:
              isLoadingStatuses ? <>-</> :
                filteredStatuses?.length > 0 ?
                  <StartupStatusSelector statuses={[...filteredStatuses]} refetchListing={refetchListing} selectedStartupData={{ pipeline_id: item?.pipeline_id, status: item?.investor_status_id }} handleSubmit={handleMoveToSelectedStatus} disabled={isAIShortlistProcessing || isShortlisting} />
                  : <Box onClick={() => {
                    handleOpenCreateDealPopup()
                  }} display={"flex"} alignItems={"center"} justifyContent={"center"} sx={{ textDecoration: "underline", textUnderlineOffset: '5px', textDecorationColor: "#3538CD", cursor: 'pointer' }}>
                    <Add style={{ width: 20, height: 20, color: "#3538CD" }} />
                    <Typography fontSize={"0.9rem"} color={"#3538CD"}> Add </Typography>
                  </Box>,
            // formatted_interested_amount: pipeline_details?._interested_amount,
            // formatted_allocated_amount: pipeline_details?._allocated_amount,
            location: location,
            // location: item?.city_id && item?.country_id ? `${item?.city_id?.name}, ${item?.country_id?.name}` : "-",
            currency: item?.currency_info
              ? item?.currency_info?.code
              : null,
            category_sub_sector: item?.category_id && item?.category_id?.length > 0
              ? `${item?.category_id?.map(item => item?.name)} ${item?.sector_id && item?.sector_id?.length > 0 ? "(" + item?.sector_id?.map(item => item?.name) + ")" : "-"}`
              : "-",
            stage: item?.stage_id && item?.stage_id?.length > 0 ? `${item?.stage_id?.map(item => item?.name)}` : "-",
            image: item?.startup_logo_path,
            pitch_deck: item?.pitchDeckFileUrl && !item?.pitchDeckFileUrl?.includes("undefined") && !item?.pitchDeckFileUrl?.includes("null") ? (
              <MemoizedTooltipIcon
                title="Pitch Deck"
                onClick={() => handleOpenPDFViewer({ row: item })}
                icon={<Description sx={{ color: theme.palette.customColors.indigo600 }} />}
              />
            ) : (
              "-"
            ),
            links: (
              (
                (item?.website_url && item?.website_url?.length > 0 || item?.linkedin_url && item?.linkedin_url?.length > 0 || item?.startup_rounds_info && Array.isArray(item?.startup_rounds_info) && item?.startup_rounds_info?.length > 0 && item?.startup_rounds_info[0]?._id)
                  ? <Box display="flex" alignItems={"center"} justifyContent={"center"} >
                    {item?.website_url && item?.website_url?.length > 0 && <MemoizedTooltipIcon
                      title="Website"
                      onClick={() => window.open(item?.website_url)}
                      icon={<LanguageOutlined sx={{ color: theme.palette.customColors.indigo600 }} />}
                    />
                    }
                    {
                      item?.linkedin_url && item?.linkedin_url?.length > 0 && <MemoizedTooltipIcon
                        title="LinkedIn"
                        onClick={() => window.open(item?.linkedin_url)}
                        icon={<LinkedIn sx={{ color: theme.palette.customColors.indigo600 }} />}
                      />
                    }
                    {
                      item?.startup_rounds_info && Array.isArray(item?.startup_rounds_info) && item?.startup_rounds_info?.length > 0 && item?.startup_rounds_info[0]?._id && <MemoizedTooltipIcon
                        title="View Round Details"
                        onClick={() => {
                          if (item?.startup_rounds_info && Array.isArray(item?.startup_rounds_info) && item?.startup_rounds_info?.length > 0 && item?.startup_rounds_info[0]?._id) {
                            Cookies.set("startup_id", item?._id);
                            navigate(location ? `view-round` : `/deal-flow/view-round`)
                          }
                        }}
                        icon={<RoundDetailsIcon fill={theme.palette.customColors.indigo600} style={{ width: 20, height: 20 }} />}
                      />
                    }
                  </Box> : '-')
            ),
            logs
          })
        })
        : [];
    }, [transformedData, filteredStatuses, selectAll || selectedIds?.size > 0, userPermissions]);
  };

  let location = window.location.pathname?.includes("deal-flow");

  const StartupLink = React.memo(({ row, children }) => {

    // console.log(row?.original?.startup_rounds_info,"row")
    return (
      <Stack onClick={() => {
        if (row?.original?._id) {
          // Cookies.set("startup_id", row?.original?._id);
          window.open(`/deal-flow/view-profile?startup_id=${row?.original?._id}`)
          // window.open(location ? `view-profile` : `/deal-flow/view-profile`);
          // navigate(location ? `view-profile` : `/deal-flow/view-profile`)
        }
      }} style={{ textDecoration: 'none', color: '#616161', fontWeight: 700, cursor: 'pointer' }}>
        {/* <Link to={`view/${row?._id}`} > */}
        {children}
      </Stack>
    )
  })

  const {
    mutateAsync: saveInterestAsync,
    status: saveInterestStatus,
    error: saveInterestError,
    isLoading: isSavingInterest,
    data: saveInterestResponse,
  } = SaveInterest();

  const {
    mutateAsync: saveFeedbackAsync,
    status: saveFeedbackStatus,
    error: saveFeedbackError,
    isLoading: isSavingFeedback,
    data: saveFeedbackResponse,
  } = SaveFeedback();
  const {
    mutateAsync: saveManageNotesAsync,
  } = SaveManageNotes();

  const [currentRow, setCurrentRow] = React.useState(null);
  const [selectedPDF, setSelectedPDF] = React.useState('');

  const handleFilterOpen = () => {
    setOpenFilter(true);
  }

  const handleFilterClose = () => {
    setOpenFilter(false)
  }

  const handleUpdateFilter = ({ query = {} }) => {
    // console.log(query,"query")
    setQueryParams(query);
    Cookies.set("startups_query", JSON.stringify(query));
    handleFilterClose();
  }

  const [openFeedbackPopup, setOpenFeedbackPopup] = React.useState(false)
  const [openShowInterestPopup, setOpenShowInterestPopup] = React.useState(false)
  const [openPitchDeckImportPopup, setOpenPitchDeckImportPopup] = React.useState(false)
  const [isPitchDeckProcessing, setIsPitchDeckProcessing] = React.useState(false)
  const [openAIShortlistPopup, setOpenAIShortlistPopup] = React.useState(false)
  // const [openManageNotes, setOpenManageNotes] = React.useState(false)

  const handlePitchDeckImportPopupClose = () => setOpenPitchDeckImportPopup(false)
  const handlePitchDeckImportPopupOpen = () => setOpenPitchDeckImportPopup(true)
  const handleAIShortlistPopupClose = () => setOpenAIShortlistPopup(false)
  const handleAIShortlistPopupOpen = () => {
    if (!selectAll && selectedIds.size === 0) {
      addToast('Select Startups Before Beginning', 'warning')
      return
    }
    clearCompletedBatches()
    setOpenAIShortlistPopup(true)
  }


  const handleFeedbackPopupOpen = ({ row }) => {
    let request = {
      startup_id: row?.original?._id,
      investor_id: investor_id
    }

    // console.log(request, "row")
    FetchStatusAsync(request).then((response) => {
      // console.log(response,"resssss")
      // setIsEnabledInterest(response?.data?.investorInfo == null)
      setIsEnabledFeedback(response?.data?.feedback == null)
      if (response?.data?.feedback !== null) {
        setOpenFeedbackPopup(false);
        setAlertMessage(`You have already submitted feedback for ${row?.original?.startup_name}. Please wait to hear back from the startup.`)
        setAlertHeading("Feedback")
        setShowAlert(true);
      }
      else {
        setOpenFeedbackPopup(true);
        setAlertMessage(null)
        setAlertHeading(null)
        setShowAlert(false);
      }
    }).catch(err => {
      addToast(err?.response?.data?.message, "error")
      // toast.error(<CustomToast message={err?.response?.data?.message} style={{ padding: "0px 15px" }} closeIcon={true} />, {
      //     duration: 4000,
      //     position: "top-right",
      //     style: {
      //         padding: "15px 30px",
      //     },
      // });
    });


    setCurrentRow(row?.original);
  }

  const handleFeedbackPopupClose = () => {
    !Boolean(selectedPDF != null && selectedPDF?.length > 0) && setCurrentRow(null)
    setOpenFeedbackPopup(false)
  }

  const handleFeedbackSubmit = ({ row, values }) => {
    // console.log(row, "row")
    let request = {
      startup_id: row?._id,
      investor_id: investor_id,
      ratings: {
        problem: values?.problem,
        market: values?.market,
        product: values?.product,
        team: values?.team,
        traction: values?.traction
      },
      investible: values?.invest,
      feedback: values?.feedback
    }
    // console.log(request, "request")
    saveFeedbackAsync(request).then(() => {
      refetchListing()
    })
    // setQueryParams(query);
    handleFeedbackPopupClose();
  }


  const handleShowInterestPopupOpen = ({ row }) => {
    // console.log(row, "row")
    let request = {
      startup_id: row?._id,
      investor_id: investor_id
    }

    // console.log(request, "row")
    // FetchStatusAsync(request).then((response) => {
    //     // console.log(response,"resssss")
    //     setIsEnabledInterest(response?.data?.investorInfo == null)
    //     // setIsEnabledFeedback(response?.data?.feedback == null)
    //     if (response?.data?.investorInfo !== null) {
    //         setOpenShowInterestPopup(false);
    //         setAlertMessage(`You have already shown investment interest in ${row?.original?.startup_name}. Please wait to hear back from the startup.`)
    //         setAlertHeading("Investment Interest")
    //         setShowAlert(true);
    //     }
    //     else {
    //         setOpenShowInterestPopup(true);
    //         setAlertMessage(null)
    //         setAlertHeading(null)
    //         setShowAlert(false);
    //     }
    // }).catch(err => {
    //     // toast.error(<CustomToast message={err?.response?.data?.message} style={{ padding: "0px 15px" }} closeIcon={true} />, {
    //     //     duration: 4000,
    //     //     position: "top-right",
    //     //     style: {
    //     //         padding: "15px 30px",
    //     //     },
    //     // });
    //     addToast(err?.response?.data?.message, "error")
    // });

    setOpenShowInterestPopup(true);
    setAlertMessage(null)
    setAlertHeading(null)
    setShowAlert(false);

    setCurrentRow(row?.original ? row?.original : row);
  }

  const handleShowInterestPopupClose = () => {
    !Boolean(selectedPDF != null && selectedPDF?.length > 0) && setCurrentRow(null);
    setOpenShowInterestPopup(false)
  }

  const handleShowInterestPopupSubmit = ({ row, values }) => {
    // console.log(row, "row")
    const payload = {
      status: "in-progress"
    }
    let request = {
      startup_id: row?._id,
      interested_amount: Number(String(values?.interested_amount)?.replaceAll(",", "")) || 0,
      investor_id: investor_id,
      currency_id: values?.currency_id,
      ...(row?.pipeline_status === "in-progress" ? { ...payload } : {})
    }
    // console.log(request, "request");
    saveInterestAsync(request).then(() => {
      refetchListing()
    })
    handleShowInterestPopupClose();
  }

  // const handleManageNotesOpen = ({ row }) => {
  //     setCurrentRow(row?.original);
  //     setOpenManageNotes(true);
  // }

  // const handleManageNotesClose = () => {
  //     setCurrentRow(null)
  //     setOpenManageNotes(false)
  // }

  // const handleManageNotesSubmit = ({ row, values }) => {
  //     let request = {
  //         startup_id: row?.startup_id,
  //         investor_id: investor_id,
  //         message: values?.message
  //     }
  //     saveManageNotesAsync(request).then(() => {
  //         refetchListing()
  //     })
  //     handleManageNotesClose();
  // }

  const {
    mutateAsync: updateStartupStatusAsync,
    status: updateStartupStatusStatus,
    error: updateStartupStatusError,
    isLoading: isUpdatingStartupStatus,
    data: updateStartupStatusResponse,
  } = ChangePipelineInvestorStatus();

  const {
    mutateAsync: inviteStartupAsync,
    status: inviteStartupStatus,
    error: inviteStartupError,
    isLoading: isInvitingStartup,
    data: inviteStartupResponse,
  } = InviteStartupPOST({ investor_id: investor_id });

  const [openShortlistConfirmationPopup, setOpenShortlistConfirmationPopup] = React.useState(false);

  const handleShortlistConfirmationPopupClose = () => {
    setOpenShortlistConfirmationPopup(false);
    setCurrentRow(null);
  }

  const handleShortlistConfirmationPopupOpen = ({ row }) => {
    setOpenShortlistConfirmationPopup(true);
    setCurrentRow(row?.original);
  }

  const handleSubmissionShortlist = ({ row }) => {
    updateStartupStatusAsync({
      payload: {
        "status": "interested",
        // "interested_shown_date": new Date().toISOString()
      }
      , pipeline_id: currentRow?.pipeline_id
    }).then((response) => {
      addToast("Moved to Shortlisted", "success")
      refetchListing();
      handleShortlistConfirmationPopupClose();
    }).catch((error) => {

    })

  }

  const [openInProgressConfirmationPopup, setOpenInProgressConfirmationPopup] = React.useState(false);

  const handleInProgressConfirmationPopupClose = () => {
    setOpenInProgressConfirmationPopup(false);
    setCurrentRow(null);
  }

  const handleInProgressConfirmationPopupOpen = ({ row }) => {
    setOpenInProgressConfirmationPopup(true);
    setCurrentRow(row?.original);
  }

  const handleSubmissionInProgress = ({ row }) => {
    updateStartupStatusAsync({
      payload: {
        "status": "in-progress",
        // "interested_shown_date": new Date().toISOString()
      }
      , pipeline_id: currentRow?.pipeline_id
    }).then((response) => {
      addToast("Moved to Selected", "success")
      refetchListing();
      handleInProgressConfirmationPopupClose();
    }).catch((error) => {

    })

  }

  const [openRejectConfirmationPopup, setOpenRejectConfirmationPopup] = React.useState(false);

  const handleRejectConfirmationPopupClose = () => {
    setOpenRejectConfirmationPopup(false);
    setCurrentRow(null);
  }

  const handleRejectConfirmationPopupOpen = ({ row }) => {
    setOpenRejectConfirmationPopup(true);
    setCurrentRow(row?.original);
  }

  const handleSubmissionReject = ({ row }) => {
    // setCurrentRow(row);
    // console.log(row);
    // updateStartupStatusAsync({
    //     "startup_id": "66f285de9ce0f2c5615f20e5",
    //     "status_code": "rejected"
    // }).then((response) => {
    //     refetchListing();
    //     handleRejectConfirmationPopupClose();
    // }).catch((error) => {

    // })

    updateStartupStatusAsync({
      payload: {
        "status": "rejected"
      }
      , pipeline_id: currentRow?.pipeline_id
    }).then((response) => {
      addToast("Moved to Rejected", "success")
      refetchListing();
      handleRejectConfirmationPopupClose();
    }).catch((error) => {

    })
  }

  const [openRequestDocumentsPopup, setOpenRequestDocumentsPopup] = React.useState(false);

  const handleRequestDocumentsPopupClose = () => {
    setOpenRequestDocumentsPopup(false);
    setCurrentRow(null);
  }

  const handleRequestDocumentsPopupOpen = ({ row }) => {
    setOpenRequestDocumentsPopup(true);
    setCurrentRow(row?.original);
  }

  const handleRequestDocuments = ({ row }) => {
    // setCurrentRow(row);
    // console.log(row);
    handleShortlistConfirmationPopupClose();
  }

  const isMediumScreen = useMediaQuery(theme.breakpoints.down('lg'));

  const [searchQueryParams, setSearchQueryParams] = useSearchParams();

  const [openInviteStartupPopup, setOpenInviteStartupPopup] = React.useState(searchQueryParams.get("ist") === "true" || false);

  const handleInviteStartupPopupClose = () => {
    searchQueryParams.delete("ist")
    setSearchQueryParams(searchQueryParams)
    setOpenInviteStartupPopup(false);
  }

  const handleInviteStartupPopupOpen = () => {
    searchQueryParams.append("ist", "true")
    setSearchQueryParams(searchQueryParams)
    setOpenInviteStartupPopup(true);
  }

  // const handleInviteStartup = async ({ payload }) => {
  //   // console.log(payload, "Please enter startup name");
  //   await inviteStartupAsync({
  //     payload, _id: investor_id
  //   }).then((response) => {
  //     refetchListing();
  //     handleInviteStartupPopupClose();
  //   }).catch((error) => {
  //     // console.log(error?.message)
  //   })
  // }

  const handleInviteStartup = async ({ payload }) => {
    await inviteStartupAsync({
      payload,
      _id: investor_id,
    })
      .then((response) => {
        if (response?.data?.statusCode === 200) {
          addToast(`Invitation sent successfully`, "success");
          handleInviteStartupPopupClose();
        } else if (response?.data?.statusCode === 409) {
          addToast(`Startup is already in your deal flow`, "warning");
        } else {
          addToast(`Something went wrong. Please try again`, "error");
        }
      })
      .catch((error) => {
        addToast(`Failed to send invitation. Please check and try again`, "error");
      });
  };

  const [openSearchBarMobile, setOpenSearchBarMobile] = useState();
  const handleOpenSearchBarMobile = () => {
    setOpenSearchBarMobile(true);
  }
  const handleCloseSearchBarMobile = () => {
    setOpenSearchBarMobile(false);
  }


  const { isLoading: isMovingToPipelineFlow, mutateAsync: moveToPipelineFlowAsync } = MoveToPipelineFlowAPI()
  const { isLoading: isChangingStatusForCurrentPipeline, mutateAsync: changeStatusForCurrentPipelineAsync } = ChangeStatusForCurrentPipeline()

  const [openMoveToPipelineFlow, setOpenMoveToPipelineFlow] = React.useState(false)
  const [openMoveToDealFlow, setOpenMoveToDealFlow] = React.useState(false)

  const handleCloseMoveToPipelineFlow = () => {
    setOpenMoveToPipelineFlow(false);
    setCurrentRow(null)
  }

  const handleOpenMoveToSelectedPipeline = ({ row }) => {
    setOpenMoveToPipelineFlow(true);
    setCurrentRow(row?.original)
  }


  const handleCloseMoveToDealFlow = () => {
    setOpenMoveToDealFlow(false);
    setCurrentRow(null)
  }

  const handleOpenMoveToDealFlow = ({ row }) => {
    setOpenMoveToDealFlow(true);
    // console.log(row, "row")
    setCurrentRow(row?.original)
  }

  const handleMoveToSelectedStatus = React.useCallback((props) => {
    // console.log(props, "props");

    const isRejected = statusTabsArray.find(item => item?.value === props?.payload?.investor_status_id).mappedValue === constants["rejected"];

    const mappedValue = statusTabsArray.find(item => item?.value === props?.payload?.investor_status_id).mappedValue;

    const payload = {
      "investor_status_id": props?.payload?.investor_status_id,
      ...(isRejected ? { rejected_by: constants["investor"] } : {}),
      ...(mappedValue ? { status: mappedValue } : {})
    };

    changeStatusForCurrentPipelineAsync({ payload: payload, pipeline_id: props?.payload?.pipeline_id }, {
      onSuccess: (successResponse) => {
        if (successResponse?.data?.statusCode === 200) {
          // setValue(props?.payload?.investor_status_id);
          refetchListing();
          handleCloseMoveToDealFlow();
        }
      },
      onError: (errorResponse) => {
        addToast(errorResponse?.response?.data?.message, "error");
      }
    });
  }, [investor_id, currentRow?.pipeline_id, changeStatusForCurrentPipelineAsync, addToast, handleCloseMoveToDealFlow]);

  const handleMoveToSelectedPipeline = React.useCallback((props) => {
    // console.log(props, "props");

    const payload = {
      "investor_pipeline_id": props?.status_value
    };

    // // console.log(payload);

    changeStatusForCurrentPipelineAsync({ payload: payload, pipeline_id: props?.pipeline_id }, {
      onSuccess: (successResponse) => {
        if (successResponse?.data?.statusCode === 200) {
          // setMainTabValue(props?.status_value);
          refetchListing()
          handleCloseMoveToPipelineFlow();
        }
      },
      onError: (errorResponse) => {
        addToast(errorResponse?.response?.data?.message, "error");
      }
    });
  }, [investor_id, currentRow?.pipeline_id, changeStatusForCurrentPipelineAsync, addToast, handleCloseMoveToPipelineFlow]);


  const actionBtnSx = {
    width: 42, height: 42,
    borderRadius: '10px',
    flexShrink: 0,
  };

  const Actions = ({ hasNoData = false }) => {
    const isSmUp = useMediaQuery(theme.breakpoints.up('sm'));
    const showLabel = isSmUp || hasNoData;
    return hasPermission("startups", "invite", userPermissions) && (
      <Box sx={{ display: 'flex', flexDirection: hasNoData ? 'column' : 'row', alignItems: 'center', gap: 1 }}>
        {/* Upload Deck */}
        {/* <Tooltip title={isPitchDeckProcessing ? 'Processing...' : ''}>
          <span>
            <IconButton
              sx={{
                ...actionBtnSx,
                ...(showLabel && {
                  width: 'auto',
                  borderRadius: '10px',
                  padding: '0 16px',
                  gap: '6px',
                  fontSize: '0.875rem',
                  fontWeight: 600,
                }),
              }}
              onClick={isPitchDeckProcessing ? undefined : handlePitchDeckImportPopupOpen}
              disabled={isPitchDeckProcessing}
            >
              {isPitchDeckProcessing
                ? <CircularProgress size={18} sx={{ color: 'inherit' }} />
                : <UploadPitchDeckIcon style={{ width: 20, height: 20, flexShrink: 0 }} />}
              {showLabel && (isPitchDeckProcessing ? 'Processing...' : 'Upload Deck')}
            </IconButton>
          </span>
        </Tooltip> */}

        {/* AI Auto-Shortlist Toggle */}
        {hasNoData == false && <Tooltip
          title="Auto-Shortlist startups based on your Investment Thesis"
          placement="bottom"
          arrow
        >
          <Box sx={{ display: "flex", alignItems: "center", mr: 1.5 }}>
            <Typography
              sx={{
                display: { xs: "none", md: "block" },
                fontSize: "0.85rem",
                fontWeight: 600,
                whiteSpace: "nowrap",
                color: theme.palette.customColors.g500,
              }}
            >
              Auto-Shortlist
            </Typography>
            <CustomSwitch
              // Previews the pending state while the confirm dialog is open.
              checked={autoShortlistConfirmDialog && pendingAutoShortlistState !== null
                ? pendingAutoShortlistState
                : autoShortlistEnabled}
              disabled={isAutoShortlisting}
              onChange={async (e) => {
              const newEnabled = e.target.checked;
              const hasRequiredFields =
                fetchedSettingFromBackend?.investment_thesis?.selected_status_id &&
                fetchedSettingFromBackend?.investment_thesis?.rejected_status_id &&
                fetchedSettingFromBackend?.investment_thesis?.stage;

              if (newEnabled && !hasRequiredFields) {
                addToast(
                  'Configure your investment thesis to use auto-shortlist',
                  'warning',
                  5000,
                  { label: 'Configure', href: '/settings?page=investment-thesis', onClick: () => navigate('/settings?page=investment-thesis') }
                );
                return;
              }

              setPendingAutoShortlistState(newEnabled);
              setAutoShortlistConfirmDialog(true);
            }}
            // disabled={
            //   !fetchedSettingFromBackend?.investment_thesis?.selected_status_id ||
            //   !fetchedSettingFromBackend?.investment_thesis?.rejected_status_id ||
            //   !fetchedSettingFromBackend?.investment_thesis?.stage
            // }
            sx={{ ml: 1 }}
            />
          </Box>
        </Tooltip>}

        {/* Invite */}
        <Primary
          sx={{
            ...actionBtnSx,
            ...(showLabel && {
              width: 'auto',
              borderRadius: '10px',
              padding: '0 16px',
              gap: '6px',
              fontSize: '14px',
              fontWeight: 600,
              lineHeight: 1,
            }),
          }}
          onClick={() => hasPermission("startups", "invite", userPermissions) && handleInviteStartupPopupOpen()}
        >
          {showLabel && <Add sx={{ fontSize: 20, flexShrink: 0 }} />}
          {showLabel ? 'Invite Startup' : 'Invite'}
        </Primary>

      </Box>
    );
  }

  React.useEffect(() => {
    refetchListing();
  }, [reset]);

  const isRequestingDocuments = false;

  const FormattedData = useFormattedData(transformedData);

  const handleOpenPDFViewer = ({ row }) => {
    setCurrentRow(row);
    // console.log(currentRow,"currentRow")
    setSelectedPDF(row?.pitchDeckFileUrl);
  }

  const handleClosePDFViewer = () => {
    setSelectedPDF(null);
    setCurrentRow(null);
  }

  const updateSector = (params) => {
    let removedSectorParamFromQuery = params;
    removedSectorParamFromQuery.sector && delete removedSectorParamFromQuery.sector;
    // Cookies.set("startups_query", JSON.stringify({ ...removedSectorParamFromQuery }));
    setQueryParams({ ...removedSectorParamFromQuery });
    setSector(null);
    setSearchStatus(false)
  }

  const currentStatuslabel = statusTabsArray?.find(item => item?.value === value)?.label;

  const handleReorderPipelines = (items) => {
    setPipelinesData({
      data: items
    })
  }

  const handleReorderStatuses = (items) => {
    setPipelineStatusesData({
      data: items
    })
  }

  const handleDeletePipeline = (items) => {
    setPipelinesData({
      data: items?.filter(el => el.value !== "All")
    });
    if (items?.filter(el => el.value !== "All")[0]?._id) {
      setMainTabValue(items?.filter(el => el.value !== "All")[0]?._id)
    }
    else {
      setMainTabValue("All")
    }
  }

  const handleDeleteStatus = (items) => {
    setPipelineStatusesData({
      data: items
    });
    setValue(items[0]?._id)
  }



  const HeaderActions = () => {
    const [anchorPipelineEl, setAnchorPipelineEl] = React.useState(null);
    const openMenuPipeline = Boolean(anchorPipelineEl);
    const handleClickMenuPipeline = (event, index) => {
      setAnchorPipelineEl(event.currentTarget);
      // setCurrentIndex(index)
      // console.log(event.currentTarget,"re")
    };
    const handleCloseMenuPipeline = (event) => {
      // console.log(event,"event")
      setAnchorPipelineEl(null);
      // setCurrentIndex(null);
    };
    return <Box sx={{ display: "flex" }}>
      <Actions />
      <WHITEBG sx={{
        // Borderless: the icon alone is the control. backgroundImage is neutralised
        // because WHITEBG paints a gradient behind the border area. No hover tint -
        // it sits next to the Filter and list/card icons, which have none either.
        border: 'none',
        backgroundImage: 'none',
        backgroundColor: 'transparent',
        '&:hover': { backgroundImage: 'none', backgroundColor: 'transparent' },
        minWidth: "unset",
        height: "44.5px",
        px: "3px",
        py: "6px",
        // Sits away from Invite Startup by the same 0.625rem the toolbar puts between
        // its own controls, plus a little breathing room on the right edge.
        ml: "0.625rem",
        mr: "-0.25rem",
      }}
        disableRipple
        onClick={handleClickMenuPipeline}
      >
        <MoreGradientIcon />
      </WHITEBG>
      {/* TO be reverted After Demo */}
      {/* {value !== "rejected" &&  */}
      <Menu
        anchorEl={anchorPipelineEl}
        id="account-menu"
        open={openMenuPipeline}
        aria-controls={openMenuPipeline ? 'fade-menu' : 'fade-menu'}
        aria-haspopup="true"
        aria-expanded={openMenuPipeline ? 'true' : 'false'}
        onClose={handleCloseMenuPipeline}
        onClick={handleCloseMenuPipeline}
        PaperProps={{
          elevation: 0,
          sx: {
            overflow: 'visible',
            filter: 'drop-shadow(0px 2px 8px rgba(0,0,0,0.32))',
            mt: 2.5,
            padding: "12px",
            borderRadius: "8px",
            "& > ul.MuiList-root": { padding: "0 !important" },
            bgcolor: theme.palette.customColors.g400,
            color: theme.palette.customColors.whiteBG,
            // '&::before': {
            //     content: '""',
            //     display: 'block',
            //     position: 'absolute',
            //     top: 1,
            //     right: 5,
            //     width: 10,
            //     height: 10,
            //     bgcolor: theme.palette.customColors.g900,
            //     transform: 'translateY(-50%) rotate(45deg)',
            //     zIndex: 0,
            // },
          },
        }}
        transformOrigin={{ horizontal: 'right', vertical: 'top' }}
        anchorOrigin={{ horizontal: 'right', vertical: 'center' }}
      >

        <>
          {pipelineTabsArray?.length < 11 && <MenuItem disableRipple sx={{ borderBottom: `1px solid ${theme.palette.customColors.g700}`, padding: '0.625rem 1rem', color: 'rgba(255, 255, 255, 0.72)', gap: '8px', '& svg': { fontSize: 18 }, '&:hover': { color: '#fff' } }} onClick={() => {
            handleOpenCreatePipelinePopup()
          }}>
            <Add />Add Pipeline
          </MenuItem>}
          {pipelineTabsArray?.length > 1 && <MenuItem disableRipple sx={{ borderBottom: `1px solid ${theme.palette.customColors.g700}`, padding: '0.625rem 1rem', color: 'rgba(255, 255, 255, 0.72)', gap: '8px', '& svg': { fontSize: 18 }, '&:hover': { color: '#fff' } }} onClick={() => {
            handleOpenPipelineFlowSettingsModal()
          }}>
            <AccountTreeOutlined />Manage Pipelines
          </MenuItem>}
          {filteredStatuses?.length < 8 && <MenuItem disableRipple sx={{ borderBottom: `${filteredStatuses?.length > 0 ? 1 : 0}px solid ${theme.palette.customColors.g700}`, padding: '0.625rem 1rem', color: 'rgba(255, 255, 255, 0.72)', gap: '8px', '& svg': { fontSize: 18 }, '&:hover': { color: '#fff' } }} onClick={() => {
            handleOpenCreateDealPopup()
          }}>
            <Add />Add Status
          </MenuItem>}
          {filteredStatuses?.length > 0 && <MenuItem disableRipple sx={{
            padding: '0.625rem 1rem', color: 'rgba(255, 255, 255, 0.72)', gap: '8px', '& svg': { fontSize: 18 }, '&:hover': { color: '#fff' }
          }} onClick={() => {
            handleOpenDealFlowSettingsModal()
          }}>
            <ViewKanbanOutlined />Manage Status
          </MenuItem>}

        </>
      </Menu>
    </Box>
  }

  const { mutateAsync: bulkUpdateInvestorStatusAsync, isLoading: isBulkUpdatingInvestorStatus } = BulkUpdateInvestorStatus();


  const handleBulkUpdatePipeline = (props) => {
    const payload = {
      investor_id,
      investor_pipeline_id: props?.status_value ?? null,
      investor_status_id: value ?? null,
      selected_ids: Array.from(selectedIds || []),
      select_all: !!selectAll,
      ...(mainTabValue && mainTabValue !== "All"
        ? { current_investor_pipeline_id: mainTabValue }
        : {}),
      // Keys match the backend filter (stage / sector), plus the search the list is showing.
      filters: {
        ...(selectedStageId && { stage: selectedStageId }),
        ...(selectedCategoryId && { category: selectedCategoryId }),
        ...(selectedSectorId && { sector: selectedSectorId }),
        ...(queryParams?.city && { city: queryParams?.city?.split(",") }),
        name: search ?? "",
      }
    };

    const selectedPipeline = pipelineTabsArray.find(
      (item) => item?.value === props?.status_value
    );

    // console.log(payload,"payload")
    bulkUpdateInvestorPipelineAsync(payload, {
      onSuccess: (response) => {
        if (response?.data?.success === false) {
          addToast(response?.data?.message || "No startups were updated.", "error");
          return;
        }
        addToast(
          `Selected Startups moved to ${selectedPipeline?.label} (Pipeline)`,
          "success"
        );
        setPage(1);
        setSelectAll(false);
        setSelectedIds(new Set());
        refetchListing();
      },
      onError: (error) => {
        console.error(error, "error");
      },
    });
    //  e.g. make API call
    // updatePipelineBulk(payload);
  }



  const { mutateAsync: bulkUpdateInvestorPipelineAsync, isLoading: isBulkUpdatingInvestorPipeline } = BulkUpdateInvestorPipeline();


  const handleBulkUpdateStatus = (props) => {
    const constants = {
      investor: "investor",
      rejected: "rejected",
    };

    const selectedStatus = statusTabsArray.find(
      (item) => item?.value === props?.status_value
    );

    const isRejected = selectedStatus.mappedValue === constants["rejected"];
    const mappedValue = selectedStatus.mappedValue;
    const payload = {
      investor_id: investor_id,
      investor_status_id: props?.status_value,
      current_investor_status_id: value ?? null,
      ...(mainTabValue !== "All" ? { investor_pipeline_id: mainTabValue } : {}),
      // 🔹 Highlighted change: always send selectedRows
      selected_ids: Array.from(selectedIds || []),
      select_all: !!selectAll,
      // 🔹 Highlighted change: removed selectAll flag
      ...(isRejected ? { rejected_by: constants["investor"] } : {}),
      ...(mappedValue ? { status: mappedValue } : {}),
      // Keys match the backend filter (stage / sector).
      filters: {
        ...(selectedStageId && { stage: selectedStageId }),
        ...(selectedCategoryId && { category: selectedCategoryId }),
        ...(selectedSectorId && { sector: selectedSectorId }),
        ...(queryParams?.city && { city: queryParams?.city?.split(",") }),
        name: search ?? "",
      }
    };

    bulkUpdateInvestorStatusAsync(payload, {
      onSuccess: (response) => {
        if (response?.data?.success === false) {
          addToast(response?.data?.message || "No startups were updated.", "error");
          return;
        }
        addToast(
          "Selected Startups moved to " + selectedStatus?.label + " (Status)",
          "success"
        );
        setPage(1);
        setSelectAll(false);
        setSelectedIds(new Set());  // reset selection
        refetchListing();
      },
      onError: (error) => {
        console.error(error, "error");
      },
    });
  }


  return (
    <>
      {/* New Modals */}
      <>
        {openMoveToPipelineFlow && <MoveToPipelineFlowPopup open={openMoveToPipelineFlow} handleClose={handleCloseMoveToPipelineFlow} handleSubmission={handleMoveToSelectedPipeline} isCreating={isMovingToPipelineFlow} options={pipelineTabsArray?.filter(item => item?.value !== "All" && item?.value !== mainTabValue)} currentPipelineID={currentRow?.pipeline_id} />
        }
        {openSettingsModal && <SettingsPopup open={openSettingsModal} settingsType={settingsType} handleClose={handleCloseSettingsModal}
          mainTabValue={mainTabValue}
          setMainTabValue={setMainTabValue}
          tabValue={value}
          setValue={setValue}
          statusTabs={statusTabsArray}
          pipelineTabs={pipelineTabsArray}
          investor_id={investor_id}
          handleReorderPipelines={handleReorderPipelines}
          handleReorderStatuses={handleReorderStatuses}
          sx={(theme) => ({
            // "& .MuiPaper-root": {
            //     backgroundColor: theme.palette.customColors.yellow_bg,
            // },
            "& > .MuiDialog-container > .MuiPaper-root": {
              borderRadius: "12px"
            }
          })}
          onEditStatus={onEditStatus}
          onEditPipeline={onEditPipeline}
          handleDeletePipeline={handleDeletePipeline}
          handleDeleteStatus={handleDeleteStatus}
          // onDeletePipelineStatus={onDeletePipelineStatus}
          // onDeletePipeline={onDeletePipeline}
          refetchStatusTabs={refetchStatusTabs}
          refetchPipelineTabs={refetchPipelineTabs}
          isLoading={isLoadingStatuses || isLoadingPipelines}
        />}
        {openCreatePipelinePopup && <CreateNewPipelineStatusPopup handleClose={handleCloseCreatePipelinePopup} open={openCreatePipelinePopup} handleSubmission={handleSubmissionCreatePipline} isCreating={isCreatingPipeline} />
        }
        {openCreateDealPopup && <CreateDealFlowPopup handleClose={handleCloseCreateDealPopup} open={openCreateDealPopup} handleSubmission={handleSubmissionCreateDealFlow} isCreating={isCreatingDealFlow} />
        }

      </>
      <AlertDialog open={showAlert} handleClose={() => { setShowAlert(false); setTimeout(() => { setAlertMessage(null); setAlertHeading(null) }, 1000) }} heading={alertHeading} subheading={alertMessage} />
      <PDFView open={Boolean(selectedPDF != null && selectedPDF?.length > 0)} pdfUrl={selectedPDF} handleClose={handleClosePDFViewer} handleFeedbackPopupOpen={handleFeedbackPopupOpen} handleShowInterestPopupOpen={handleShowInterestPopupOpen} currentRow={currentRow} isEnabledFeedback={isEnabledFeedback} isEnabledInterest={isEnabledInterest} />
      <InviteStartupPopup open={openInviteStartupPopup} handleClose={handleInviteStartupPopupClose} isSharingDocuments={false} refetchListing={refetchListing} handleSubmission={handleInviteStartup} isInvitingStartup={isInvitingStartup} affiliate_code={userDetails?.affiliate_code} slug={pipelineTabsArray?.find(pipeline => pipeline?.value === mainTabValue)?.slug} pipeline_id={mainTabValue} />
      <ModalComponent open={openFilter} onClose={handleFilterClose} style={{ maxWidth: 640, width: "100%" }}>
        <FilterPopup queryParams={queryParams} setQueryParams={setQueryParams} handleClose={handleFilterClose} handleSubmit={handleUpdateFilter} stage={stage} category={category} sector={sector} setStage={setStage} setCategory={setCategory} setSector={setSector} uniqueCountryCity={transformedData?.uniqueCountryCity || []} />
      </ModalComponent>
      <InvitedConfirmationPopup open={openInvitedConfirmationPopup} handleClose={handleInvitedConfirmationPopupClose} handleSubmission={handleSubmissionInvited} heading={"Move to New"} ActionText={"Submit"} subheading={"Are you sure you want to move to new startups?"} isLoading={isUpdatingStartupStatus} currentRow={currentRow} optional={true} />
      <ShortlistConfirmationPopup open={openShortlistConfirmationPopup} handleClose={handleShortlistConfirmationPopupClose} handleSubmission={handleSubmissionShortlist} heading={"Move to Shortlist"} ActionText={"Submit"} subheading={"Are you sure you want to move to shortlisted startups?"} isLoading={isUpdatingStartupStatus} currentRow={currentRow} optional={true} />
      <InProgressConfirmationPopup open={openInProgressConfirmationPopup} handleClose={handleInProgressConfirmationPopupClose} handleSubmission={handleSubmissionInProgress} heading={"Move to Selected"} ActionText={"Submit"} subheading={"Are you sure you want to move to selected startups?"} isLoading={isUpdatingStartupStatus} currentRow={currentRow} optional={true} />
      <RejectedConfirmationPopup open={openRejectConfirmationPopup} handleClose={handleRejectConfirmationPopupClose} handleSubmission={handleSubmissionReject} heading={"Move to Rejected"} ActionText={"Reject"} subheading={"Are you sure you want to move to rejected startups?"} isLoading={isUpdatingStartupStatus} currentRow={currentRow} optional={false} />
      <RequestDocumentsPopup open={openRequestDocumentsPopup} handleClose={handleRequestDocumentsPopupClose} handleSubmission={handleRequestDocuments} heading={"Request Documents"} ActionText={"Request"} subheading={"Are you sure you want to request documents for selected startup?"} isLoading={isRequestingDocuments} currentRow={currentRow} />
      <ModalComponent open={openFeedbackPopup} onClose={handleFeedbackPopupClose} style={{ maxWidth: 640, width: "100%" }}>
        <FeedbackPopup currentRow={currentRow} handleClose={handleFeedbackPopupClose} handleSubmit={handleFeedbackSubmit} />
      </ModalComponent>
      <ModalComponent open={openShowInterestPopup} onClose={handleShowInterestPopupClose} style={{ maxWidth: 640, width: "100%" }}>
        <ShowInterestPopup currentRow={currentRow} handleClose={handleShowInterestPopupClose} handleSubmit={handleShowInterestPopupSubmit} />
      </ModalComponent>
      {/* <ModalComponent open={openManageNotes} onClose={handleManageNotesClose} style={{ maxWidth: 800, width: "100%" }}>
                <ManageNotes currentRow={currentRow} handleClose={handleManageNotesClose} handleSubmit={handleManageNotesSubmit} />
            </ModalComponent> */}
      <PitchDeckImportPopup
        open={openPitchDeckImportPopup}
        handleClose={handlePitchDeckImportPopupClose}
        investor_id={investor_id}
        refetchListing={refetchListing}
        onProcessingChange={setIsPitchDeckProcessing}
      />
      <AIShortlistPopup
        open={openAIShortlistPopup}
        handleClose={handleAIShortlistPopupClose}
        investor_id={investor_id}
        selectedIds={selectedIds}
        selectAll={selectAll}
        selectedCount={selectAll ? Number(transformedData?.count) - Number(selectedIds?.size) : Number(selectedIds?.size)}
        activeFilters={{
          category: selectedCategoryId || [],
          sector: selectedSectorId || [],
          stage: selectedStageId || [],
          name: search || '',
        }}
        investorPipelineId={mainTabValue !== 'All' ? mainTabValue : undefined}
        investorStatusId={value && value !== 'All' ? value : undefined}
        refetchListing={refetchListing}
        onProcessingChange={setIsAIShortlistProcessing}
      />
      <ThemeBGWrapper>
        {/* No `maxHeight: 'unset'` on the flex-wrap: keeping BreadcrumbHeader's default
            maxHeight:30 makes this header the SAME height as every other page (e.g. Reels ~60px).
            The taller controls (Invite Startup / kebab) overflow the 30px row into the 15px
            top-padding and the divider's 16px marginTop gap - both have room, neither clips. */}
        <BreadcrumbHeader title={"Pipelines"} sx={{ paddingBottom: "0 !important" }} Actions={HeaderActions} />
        <Grid container xs={12} padding={{ xs: "0 0rem 1rem 0rem", md: "0 0rem 2rem 0rem" }} justifyContent={"space-between"}>

          <Grid container xs={12} pt={0} pb={0} spacing={0} display={"flex"} justifyContent={"space-between"} marginLeft={0} alignContent={"flex-start"} >
            {/* <Grid item xs={10} lg={10}> */}
            {
              /* Geometry comes from DealFlowToolbar, shared with the board view, so the two
                 rows cannot drift apart again. paddingInline stays here because the board
                 carries it on its outer container instead. */
              <DealFlowToolbar
                sx={{
                  paddingInline: { xs: "0.8rem !important", sm: '1rem !important', md: '2rem !important', lg: '2rem !important' },
                  
                }}
                left={<>
                  <TabContext value={mainTabValue}>
                    {/* maxWidth 100%, matching the board view's tab strip - it was capped at
                        65% of a group that is itself 75% of the row, so the tabs only got
                        about half the width and the last one clipped.
                        minWidth: 0 - a flex item defaults to min-width:auto, so without this
                        the strip refuses to shrink below its content and runs underneath the
                        Add button once there are enough pipelines to overflow. */}
                    {/* No overflow:hidden - CustomTabs renders a scrollable MUI TabList with
                        scrollButtons={false}, so clipping it here left a half-cut tab with no
                        way to reach it. minWidth: 0 alone stops the strip shoving the Add
                        button, and MUI's own scroller handles the overflow. */}
                    <Box maxWidth="100%" sx={{ minWidth: 0 }}>
                      <CustomTabs data={pipelineTabsArray} value={mainTabValue} isSmallScreen={isSmallScreen} className={classes?.mainScrollTabs} titleStyle={{ fontSize: '1.10rem' }} handleChange={handleMainTabChange} key={"Tabs Tabs"} sx={{ paddingTop: '0rem' }} tabStyle={{ padding: "0.8rem 2rem 1rem 2rem" }} bgColor="transparent" />
                    </Box>
                  </TabContext>
                  <Box alignItems={"center"} sx={{
                    marginBottom: { sm: "0rem", md: '0rem' },
                    // Never let the tab strip squeeze the Add button.
                    flexShrink: 0,
                    display: {
                      xs: "none",
                      md: pipelineTabsArray?.length < 11 ? "flex" : "none"
                    }
                  }}>
                    <WHITEBG
                      sx={{
                        display: 'inline-flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        gap: '6px',
                        minWidth: "78px",
                        height: "40px",
                        flexShrink: 0,
                        // No border / backgroundColor overrides here: WHITEBG paints its
                        // gradient border via a transparent border + backgroundClip, so a
                        // solid border or an opaque backgroundColor would cover it.
                        // "& > .MuiButton-icon.MuiButton-startIcon":
                        // {
                        //     marginRight: isMediumScreen ? 0 : '0.5rem',
                        //     marginLeft: isMediumScreen ? 0 : '-0.25rem'
                        // }
                      }}
                      onClick={() => {
                        handleOpenCreatePipelinePopup()
                      }}
                    // startIcon={<Add sx={{ width: 20, height: 20 }} />}
                    >
                      <PlusGradientIcon /> Add
                      {/* Pipeline */}
                    </WHITEBG>
                  </Box>
                  {/* <Box px={isSmallScreen ? "1rem" : "2rem"} bgColor={theme.palette.customColors.yellow_bg}> */}
                  {/* </Box> */}
              </>}
              right={<>
                  {/* No wrapper Boxes here, matching the board view: DealFlowToolbar's right
                      group already sets display/alignItems/gap. The two nested Boxes that
                      used to sit here re-declared gap (0.5rem vs the toolbar's 0.625rem) and
                      added marginTop 0.2rem, so the search and icons sat at a different size
                      and height than the board's however much the toolbar was shared. */}
                      {/* <CustomInputField
                      autoComplete="off"
                      sx={{
                        marginBottom: 0,
                        "& > .MuiFilledInput-root": {
                          borderColor: `${theme.palette.customColors.b50} !important`,
                          borderRadius: "8px",
                          height: "44px", // Added fixed height for consistency
                        },
                        flexGrow: 1, // Added to take available space
                      }}
                      fullWidth
                      value={search}
                      name={`search_${Math.random().toString(36).substring(7)}`}
                      onKeyPress={(e) => {
                        if (e.key === "Enter") {
                          refetchListing();
                          if (search) {
                            setSearchStatus(true);
                          }
                          setPage(1);
                        }
                      }}
                      onChange={(event) => {
                        setSearch(event.target.value);
                        Cookies.set("search_startups", event.target.value);
                        setSearchStatus(false);
                      }}
                      size="small"
                      startAdornment={
                        <Search
                          sx={{
                            padding: "0rem 0rem 0rem 0.5rem",
                            color: theme.palette.customColors.g100, // Added for better visibility
                          }}
                        />
                      }
                      placeholder={"Search by name"}
                    /> */}

                      {/* Desktop/Laptop → always show full search */}
                      {/* Fixed 224px, matching the board view. It was flexGrow: 1, so the
                          field stretched to whatever width was left over - a different width
                          in each view, which moved the Filter and view-toggle icons every
                          time you switched. The 44px height already matched. */}
                      <Box
                        sx={{
                          display: { xs: "none", md: "none", lg: "block" },
                          width: "224px",
                          flexShrink: 0,
                        }}
                      >
                        <CustomInputField
                          autoComplete="off"
                          sx={{
                            marginBottom: 0,
                            "& > .MuiFilledInput-root": {
                              borderColor: `${theme.palette.customColors.b50} !important`,
                              borderRadius: "8px",
                              height: "44px",
                            },
                          }}
                          fullWidth
                          value={search}
                          name="search_desktop"
                          onKeyPress={(e) => {
                            if (e.key === "Enter") {
                              refetchListing();
                              if (search) setSearchStatus(true);
                              setPage(1);
                            }
                          }}
                          onChange={(event) => {
                            setSearch(event.target.value);
                            Cookies.set("search_startups", event.target.value);
                            setSearchStatus(false);
                          }}
                          size="small"
                          startAdornment={<SearchGradientIcon />}
                          placeholder="Search by name"
                        />
                      </Box>

                      {/* Mobile/Tablet → Search Icon triggers full-width search bar */}
                      <Box
                        sx={{ display: { xs: "block", md: "block", lg: "none" } }}
                      >
                        {!openSearchBarMobile ? (
                          <IconButton onClick={handleOpenSearchBarMobile} disableRipple={true}>
                            <SearchGradientIcon
                            />
                          </IconButton>
                        ) : (
                          <Dialog
                            open={openSearchBarMobile}
                            onClose={handleCloseSearchBarMobile}
                            fullWidth
                            maxWidth="sm"
                            PaperProps={{
                              sx: {
                                borderRadius: "8px",
                                padding: "0",
                                background: theme.palette.customColors.whiteBG,
                                width: "100%", // ✅ full width
                                margin: "0 0.5rem 0 0.5rem", // ✅ no side margin
                              },
                            }}
                            sx={{
                              "& .MuiDialog-container": {
                                alignItems: "flex-start",
                              },
                              "& .MuiDialog-paper": {
                                top: "60px",
                              },
                            }}
                          >
                            <Paper
                              sx={{
                                background: theme.palette.customColors.whiteBG,
                                borderRadius: "8px",
                                position: "relative",
                                padding: "0.5rem",
                              }}
                            >
                              <Grid container spacing={2}>
                                <Grid item xs={12}>
                                  <CustomInputField
                                    autoComplete="off"
                                    autoFocus
                                    fullWidth
                                    value={search}
                                    name="search_mobile"
                                    onKeyPress={(e) => {
                                      if (e.key === "Enter") {
                                        refetchListing();
                                        if (search) setSearchStatus(true);
                                        setPage(1);
                                        setOpenSearchBarMobile(false);
                                      }
                                    }}
                                    onChange={(event) => {
                                      setSearch(event.target.value);
                                      Cookies.set(
                                        "search_startups",
                                        event.target.value
                                      );
                                      setSearchStatus(false);
                                    }}
                                    size="small"
                                    startAdornment={<SearchGradientIcon />}
                                    placeholder="Search"
                                    sx={{
                                      "& > .MuiFilledInput-root": {
                                        borderColor: `${theme.palette.customColors.b50} !important`,
                                        borderRadius: "8px",
                                        height: "44px",
                                      },
                                      marginBottom: "0px",
                                    }}
                                  />
                                </Grid>
                              </Grid>
                            </Paper>
                          </Dialog>
                        )}
                      </Box>

                      {/* {search !== "" && searchStatus !== false && <Primary
                        onClick={() => {
                          if (
                            searchStatus &&
                            (search !== "" ||
                              Object.keys(queryParams)?.length > 0)
                          ) {
                            setSearch("");
                            Cookies.set("search_startups", "");
                            setQueryParams({});
                            Cookies.remove("startups_query");
                            setReset(!reset);
                          } else {
                            Cookies.set("search_startups", search);
                            refetchListing();
                          }
                          setSearchStatus((oldVal) => !oldVal);
                          setPage(1);
                        }}
                        sx={{
                          display: { xs: "none", md: "none", lg: "flex" },
                          minWidth: { xs: "90px", md: "90px" },
                          padding: ".7rem 1.25rem",
                          height: "44px", // Added fixed height
                          bgcolor:
                            searchStatus &&
                              (search !== "" ||
                                Object.keys(queryParams)?.length > 0)
                              ? "#e9f5f8"
                              : theme.palette.customColors.b300,
                          ":hover": {
                            bgcolor:
                              searchStatus &&
                                (search !== "" ||
                                  Object.keys(queryParams)?.length > 0)
                                ? "#e9f5f8"
                                : theme.palette.customColors.b400,
                          },
                          border: `1px solid ${searchStatus &&
                            (search !== "" ||
                              Object.keys(queryParams)?.length > 0)
                            ? theme.palette.customColors.b300
                            : "transparent"
                            }`,
                          color:
                            searchStatus &&
                              (search !== "" ||
                                Object.keys(queryParams)?.length > 0)
                              ? theme.palette.customColors.b300
                              : "white",
                          borderRadius: "8px", // Added for consistency
                        }}
                      >
                        {searchStatus &&
                          (search !== "" || Object.keys(queryParams)?.length > 0)
                          ? "Reset"
                          : "Search"}
                      </Primary>} */}

                      <Tooltip title="Filter">
                        <WHITEBG sx={{
                          // Borderless: the icon alone is the control. backgroundImage is
                          // neutralised because WHITEBG paints a gradient behind the border area.
                          border: 'none',
                          backgroundImage: 'none',
                          backgroundColor: 'transparent',
                          '&:hover': { backgroundImage: 'none', backgroundColor: 'transparent' },
                          minWidth: "unset",
                          height: "44.5px",
                          px: "3px",
                          py: "6px"
                        }}
                          disableRipple
                          onClick={() => handleFilterOpen()}
                        >
                          <FilterGradientIcon active={Object.keys(queryParams)?.length > 0} />
                        </WHITEBG>
                      </Tooltip>
                      <DealFlowViewToggle />
              </>}
              />}
            {/* <Grid item xs={12} display={"flex"} justifyContent={"space-between"} alignItems={"center"} sx={{ gap: "0.5rem" }} paddingInline={{ xs: "0.5rem !important", sm: '1rem !important', md: '1rem !important', lg: '2rem !important' }} marginRight={"0rem"} mb={1}>
                                <Grid item xs={12} md={4} display={"flex"} flexWrap={"nowrap"} container gap={1}>
                                    <CustomInputField
                                        autoComplete="off"
                                        sx={{
                                            marginBottom: 0,
                                            "& > .MuiFilledInput-root": {
                                                borderColor: `${theme.palette.customColors.b50} !important`,
                                                borderRadius: '8px'
                                            }
                                        }}
                                        fullWidth
                                        value={search}
                                        name={`search_${Math.random().toString(36).substring(7)}`}  // Set a random name attribute
                                        onKeyPress={(e) => {
                                            if (e.key === 'Enter') {
                                                // alert(e.target.value);
                                                refetchListing()
                                                if (search) {
                                                    setSearchStatus(true)
                                                }
                                                setPage(1);
                                            }
                                        }}
                                        onChange={(event) => {
                                            setSearch(event.target.value)
                                            Cookies.set("search_startups", event.target.value);
                                            setSearchStatus(false)
                                        }}
                                        size="small"
                                        startAdornment={<>
                                            <SearchGradientIcon />
                                        </>}
                                        placeholder={'Search by name'}
                                    />
                                    <Primary onClick={() => {
                                        if (searchStatus && (search !== '' || Object.keys(queryParams)?.length > 0)) {
                                            setSearch('')
                                            Cookies.set("search_startups", '');
                                            setQueryParams({});
                                            Cookies.remove("startups_query");
                                            setReset(!reset)
                                        } else {
                                            Cookies.set("search_startups", search);
                                            refetchListing()
                                        }
                                        setSearchStatus((oldVal) => !oldVal)
                                        setPage(1);
                                    }} sx={{ display: { xs: "block", md: 'block' }, minWidth: { xs: "90px", md: "90px" }, padding: ".7rem 1.25rem", bgcolor: searchStatus && (search !== '' || Object.keys(queryParams)?.length > 0) ? "#e9f5f8" : theme.palette.customColors.b300, ":hover": { bgcolor: searchStatus && (search !== '' || Object.keys(queryParams)?.length > 0) ? "#e9f5f8" : theme.palette.customColors.b400 }, border: `0px solid ${searchStatus && (search !== '' || Object.keys(queryParams)?.length > 0) ? "black" : "inherit"}`, color: searchStatus && (search !== '' || Object.keys(queryParams)?.length > 0) ? theme.palette.customColors.b300 : "white" }}  >{(searchStatus && (search !== '' || Object.keys(queryParams)?.length > 0)) ? "Reset" : "Search"}</Primary>
                                    <Tooltip title="Filter">
                                        <IconButton sx={{ marginLeft: "auto", display: { xs: 'flex', md: "flex" }, marginBlock: 'auto' }} onClick={() => handleFilterOpen()}>
                                            <FilterGradientIcon active={Object.keys(queryParams)?.length > 0} />
                                        </IconButton>
                                    </Tooltip>
                                </Grid>
                            </Grid> */}
            <TabContext value={value}>
              {/* The status row is header, not body: it renders straight away rather than
                  shimmering, so switching between the list and board views never looks like
                  the page reloaded. Only the body below carries a skeleton. */}
              {<Grid item xs={12} paddingInline={{ xs: "0.8rem !important", sm: '1rem !important', md: '2rem !important', lg: '2rem !important' }} marginRight={"0rem"} >
                <Grid xs={12} container sx={{
                  justifyContent: "space-between",
                  // ...(!isLoadingStartupListing && !isLoadingStatuses && !isLoadingPipelines && transformedData !== null
                  //   ? { bgcolor: 'transparent' }
                  //   : {
                      bgcolor: 'white',
                      borderRadius: '8px 8px 0 0',
                      borderInline: `1px solid ${theme.palette.customColors.b50}`,
                      borderBlockStart: `1px solid ${theme.palette.customColors.b50}`,
                    // }),
                }}>
                  <Grid width={selectAll || selectedIds?.size > 0 ? { xs: "60%", sm: "70%", md: "80%", lg: "auto" } : "100%"} sx={{
                    display: 'flex', justifyContent: "flex-start",
                    // lg+: the selection summary shows beside Actions, so the tabs take what is left.
                    ...(selectAll || selectedIds?.size > 0 ? { flex: { lg: 1 }, minWidth: { lg: 0 } } : {}),
                  }}>
                    {statusTabsArray?.length > 0 &&
                      <CustomTabs
                        variant="submenu"
                        titleStyle={{ fontSize: '1rem' }}
                        tabStyle={{ padding: { xs: '0.5rem 1rem 0rem' } }}
                        sx={{
                          border: '0px solid black !important',
                          width: 'fit-content'
                        }}
                        bgColor={"transparent"}
                        allowScrollButtonsMobile={true}
                        data={
                          [...statusTabsArray?.map(item => {
                            return ({ ...item, label: `${item?.label} ${value === item?.value && isLoadingStartupListing === false && startupListingStatus == "success" && transformedData?.count && transformedData?.count != 0 ? `(${transformedData?.count})` : ""}` })
                          })]
                        } value={value} handleChange={handleTabChange}
                        tabFlexContainerSx={{
                          gap: "0.5rem",
                          paddingRight: "1rem"
                        }}
                        isSmallScreen={isSmallScreen} className={classes.scrollTabs} key={"Tabs Tabs"} indicatorFullSize={false} />
                    }
                    {/* Same wrapper as the pipeline Add above: the row is a stretch
                        flex container, so without display:flex + alignItems:center the
                        button rides the top edge instead of sitting level with the tabs. */}
                    <Box alignItems={"center"} sx={{
                      flexShrink: 0,
                      display: { xs: "none", md: 'flex' },
                    }}>
                      {statusTabsArray?.length < 8 && <Secondary
                        sx={{
                          // Same footprint as the pipeline Add above.
                          display: 'inline-flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          gap: '6px',
                          minWidth: "78px",
                          height: "40px",
                          flexShrink: 0,
                        }}
                        onClick={() => {
                          handleOpenCreateDealPopup()
                        }}
                      // startIcon={<Add sx={{ width: 20, height: 20 }} />}
                      >
                        <PlusGradientIcon /> Add
                        {/* Deal */}
                      </Secondary>}
                    </Box>
                  </Grid>
                  {/* Floating bulk actions while startups are selected (same bar as the board view). */}
                  <SelectionActionBar
                    // Sit above the table's pagination footer instead of covering the page numbers.
                    avoidSelector=".startups-listing .MuiPagination-root"
                    count={selectAll ? Number(transformedData?.count) - Number(selectedIds?.size) : Number(selectedIds?.size)}
                    onClear={() => { setSelectAll(false); setSelectedIds(new Set()); }}
                    actions={[
                      ...(filteredStatuses?.length > 0
                        ? [{
                          key: "status", label: "Status", icon: <ViewKanbanOutlined />, loading: isBulkUpdatingInvestorStatus,
                          menu: {
                            title: "Statuses", searchPlaceholder: "Search statuses...", optionIcon: <ViewKanbanOutlined />,
                            options: statusTabsArray?.filter((item) => item?.value !== value),
                            onSelect: (option) => handleBulkUpdateStatus({ status_value: option.value }),
                            footer: [
                              filteredStatuses?.length < 8 && { key: "add", label: "Add Status", icon: <Add />, onClick: handleOpenCreateDealPopup },
                              { key: "manage", label: "Manage Status", icon: <SettingsOutlined />, onClick: handleOpenDealFlowSettingsModal },
                            ],
                          },
                        }]
                        : []),
                      ...(pipelineTabsArray?.length > 1
                        ? [{
                          key: "pipeline", label: "Pipeline", icon: <AccountTreeOutlined />, loading: isBulkUpdatingInvestorPipeline,
                          menu: {
                            title: "Pipelines", searchPlaceholder: "Search pipelines...", optionIcon: <AccountTreeOutlined />,
                            options: pipelineTabsArray?.filter((item) => item?.value !== mainTabValue),
                            onSelect: (option) => handleBulkUpdatePipeline({ status_value: option.value }),
                            footer: [
                              pipelineTabsArray?.length < 11 && { key: "add", label: "Add Pipeline", icon: <Add />, onClick: handleOpenCreatePipelinePopup },
                              { key: "manage", label: "Manage Pipelines", icon: <SettingsOutlined />, onClick: handleOpenPipelineFlowSettingsModal },
                            ],
                          },
                        }]
                        : []),
                      ...(hasPermission("startups", "manage", userPermissions) && isInNewStatus
                        ? [{
                          key: "ai-shortlist", label: "AI Shortlist", icon: <SparklesIcon width={16} height={16} />, highlight: true,
                          onClick: () => handleAIShortlistPopupOpen(),
                          disabled: isAIShortlistProcessing || isShortlisting,
                          loading: isAIShortlistProcessing || isShortlisting,
                        }]
                        : []),
                    ]}
                  />
                </Grid>
              </Grid>}
            </TabContext>
            {/* { */}
            {/* <Grid item xs={12} md={12} pt={"0 !important"} marginInline={"auto"} maxWidth={"100%"}> */}

            {(isLoadingStartupListing || isLoadingStatuses || isLoadingPipelines || transformedData === null) ?
              // Shaped like the listing it replaces - the same columns (so it follows the
              // permission-dependent ones), avatar + name + email in the Name cell, a round
              // reel button, the status pill, the icon columns and the pagination footer -
              // so the table does not resize when the rows land.
              <Box className='startups-listing' width={"100%"} maxHeight="100%" paddingLeft={"2rem"} maxWidth={"100%"} overflow={"hidden"} paddingInline={{ xs: "0.8rem !important", sm: '1rem !important', md: '2rem !important', lg: '2rem !important' }}>
                <DealFlowListSkeleton
                  columns={columns}
                  rows={limit > 10 ? 10 : limit}
                  sx={{ borderRadius: '0 0 8px 8px', border: `1px solid ${theme.palette.customColors.b50}` }}
                />
              </Box>
              : <Box className='startups-listing' width={"100%"} maxHeight="100%" paddingLeft={"2rem"} maxWidth={"100%"} overflow={"hidden"} paddingInline={{ xs: "0.8rem !important", sm: '1rem !important', md: '2rem !important', lg: '2rem !important' }}>
                <AsyncTableListing
                  columns={columns}
                  // Keep the bordered container + status tabs + column header when a
                  // status/search returns nothing, showing the empty state in the body
                  // instead of collapsing the whole table - so empty and populated states
                  // look identical bar the rows.
                  emptyInBody
                  // Phone cards carry every column the desktop table shows (not the default
                  // 4), so no row info is dropped on mobile. Deal Flow has ~13 value columns;
                  // 20 is a safe ceiling that shows them all.
                  cardFieldLimit={20}
                  // data={[]}
                  tabValue={value}
                  data={FormattedData}
                  // title={"Investors"}
                  // chipText={`${data?.length}${isSmallScreen ? "" : " Investors"}`}
                  // actions={Actions}
                  noDataPlaceHolderImage={NoStartupsIcon}
                  // noDataPlaceHolderImage={value == "invited" ? placeHolderImageNew : value == "interested" ? placeHolderImageShortlisted : value == "in-progress" ? placeHolderImageShortlisted : value == "rejected" ? placeHolderImageRejected : placeHolderImageNew}
                  noDataTitle={
                    // Only the New tab is where a startup enters the pipeline, so only it
                    // invites. Shortlisted / Selected / Rejected fill up by moving rows
                    // between statuses - there "Invite startups..." plus an Invite button
                    // is the wrong action, so those tabs get a plain "No Data".
                    // `value` is the status _id, not its mapped value, so this goes
                    // through isInNewStatus (defined above) rather than comparing to "invited".
                    isInNewStatus
                      ? (transformedData?.count === 0 && !search?.trim() && !searchStatus
                        ? "Invite startups to start building your deal flow"
                        : "No Startups in this List")
                      : "No Data"
                  }
                  noDataSubTitle={""}
                  actions={isInNewStatus ? () => <Actions hasNoData={true} /> : undefined}
                  CustomLink={StartupLink}
                  page={page}
                  setPage={setPage}
                  limit={limit}
                  setLimit={setLimit}
                  count={transformedData?.count}
                  RowActions={RowActions}
                  // Mobile card: three-dot menu -> header top-right; contact (message)
                  // icon -> bottom-left next to the Status dropdown. Reel + Pitch Deck
                  // sit bottom-right (cardIcon columns). Desktop table is unchanged.
                  renderCardMenu={(row) => <RowActions row={row} slot="menu" />}
                  renderCardContact={(row) => <RowActions row={row} slot="contact" />}
                  sx={{ borderRadius: '0 0 8px 8px', border: `1px solid ${theme.palette.customColors.b50}`, ...(transformedData?.count === 0 ? { height: "64dvh" } : {}) }}
                  refetchListing={refetchListing}
                  maxHeight={transformedData?.count > 10 ? "calc(100vh - 13rem)" : "calc(100vh - 14rem)"}
                  setSelectedIds={setSelectedIds}
                  selectedIds={selectedIds}
                  selectAll={selectAll}
                  setSelectAll={setSelectAll}
                  hidden_columns={hiddenColumns}
                  renderExpandedRow={(row, hiddenCols) => <StartupRowDetails row={row} hiddenColumns={hiddenCols} />}
                  
                />
              </Box>
            }

            {/* </Grid>} */}
            {/* <Grid item xs={2} lg={2}> */}

          </Grid>
        </Grid>
      </ThemeBGWrapper>

      {/* Auto-Shortlist Confirmation Dialog */}
      <DeleteConfirmationDialog
        open={autoShortlistConfirmDialog}
        handleClose={() => setAutoShortlistConfirmDialog(false)}
        handleSubmission={async () => {
          const nextEnabled = pendingAutoShortlistState;
          const previousEnabled = autoShortlistEnabled;
          // Optimistic: rolled back on failure.
          setAutoShortlistEnabled(nextEnabled);
          const invitedStatusId = pipelineStatusesData?.data?.find((s) => s?.mappedValue === 'invited')?._id;
          try {
            // Both calls in parallel, so the wait is the slower one rather than the
            // sum - the snackbar lands with the dialog close, not a round trip later.
            const [, invitedCount] = await Promise.all([
              toggleAutoShortlistAsync({ investor_id, enabled: nextEnabled }),
              nextEnabled
                ? fetchInvitedCount({ investor_id, pipelineId: mainTabValue, statusId: invitedStatusId })
                : null,
            ]);
            queryClient.invalidateQueries([`master-listing-template-all-investor-types-fetch-all/deal_flow${investor_id}`]);
            // Closing and showing in one tick: React batches them into a single
            // render, so the dialog leaves as the snackbar arrives.
            setAutoShortlistConfirmDialog(false);
            if (!nextEnabled) {
              // Turning it off mid-run should drop the pending refresh and its snackbar.
              clearAutoShortlistTimer();
              setIsAutoShortlisting(false);
              if (autoShortlistBatchRef.current) {
                removeBatch(autoShortlistBatchRef.current);
                autoShortlistBatchRef.current = null;
              }
              addToast('Auto-shortlist disabled', 'success');
            } else if (invitedCount === 0) {
              // Nothing queued, so there is no progress to show.
              addToast('Auto-shortlist enabled', 'success');
            } else {
              // No reload here - the hook refreshes once when the queue settles.
              startAutoShortlistWithSnackbar(fetchedSettingFromBackend?.auto_shortlist?.delay_ms);
            }
          } catch (err) {
            console.error('Auto-shortlist error:', err);
            setAutoShortlistEnabled(previousEnabled);
            setAutoShortlistConfirmDialog(false);
            addToast('Error updating auto-shortlist setting', 'error');
          }
        }}
        heading={pendingAutoShortlistState ? 'Enable Auto-Shortlist?' : 'Disable Auto-Shortlist?'}
        subheading={pendingAutoShortlistState
          ? 'When enabled, every new startup entering your deal flow will be automatically categorized as either Selected or Rejected based on your investment thesis.'
          : 'When disabled, new startups will no longer be automatically shortlisted.' }
          // You can still use the manual AI Shortlist feature to evaluate startups.'}
        ActionText={pendingAutoShortlistState ? 'Enable' : 'Disable'}
        CancelText="Cancel"
        maxWidth="xs"
        sx={{
          "& > .MuiDialog-container > .MuiPaper-root": {
            maxWidth: 450,
            borderRadius: "20px"
          }
        }}
      />

      {/* Reel Modal Overlay */}
      <ReelModal
        open={reelModalOpen}
        onClose={handleCloseReel}
        item={selectedReelItem}
        investor_id={investor_id}
        viewType={selectedReelViewType}
        userPermissions={userPermissions}
        addToast={addToast}
      />
    </>
  )
}

export default StartupsListing